document.documentElement.classList.add("js");

const root = document.documentElement;
const body = document.body;
const announcementBar = document.querySelector(".announcement-bar");
const siteHeader = document.querySelector(".site-header");

document.addEventListener("click", (event) => {
  const trigger = event.target.closest("[data-scroll-target]");

  if (!trigger) {
    return;
  }

  const selector = trigger.getAttribute("data-scroll-target");
  const target = selector ? document.querySelector(selector) : null;

  if (target) {
    target.scrollIntoView({ behavior: "auto", block: "start" });
  }
});

if (siteHeader) {
  const mobileMenuToggle = siteHeader.querySelector("[data-mobile-menu-toggle]");
  const mobileMenu = siteHeader.querySelector("[data-mobile-menu]");

  const setMobileMenuOpen = (isOpen) => {
    if (!mobileMenuToggle || !mobileMenu) {
      return;
    }

    mobileMenuToggle.setAttribute("aria-expanded", String(isOpen));
    mobileMenuToggle.setAttribute("aria-label", isOpen ? "Close navigation" : "Open navigation");
    mobileMenu.setAttribute("aria-hidden", String(!isOpen));
    siteHeader.classList.toggle("is-mobile-menu-open", isOpen);
    body.classList.toggle("has-mobile-menu-open", isOpen);
  };

  mobileMenuToggle?.addEventListener("click", () => {
    setMobileMenuOpen(mobileMenuToggle.getAttribute("aria-expanded") !== "true");
  });

  mobileMenu?.addEventListener("click", (event) => {
    if (event.target.closest("a")) {
      setMobileMenuOpen(false);
    }
  });

  document.addEventListener("click", (event) => {
    if (siteHeader.classList.contains("is-mobile-menu-open") && !siteHeader.contains(event.target)) {
      setMobileMenuOpen(false);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && siteHeader.classList.contains("is-mobile-menu-open")) {
      setMobileMenuOpen(false);
      mobileMenuToggle?.focus();
    }
  });

  window.matchMedia("(min-width: 921px)").addEventListener("change", (event) => {
    if (event.matches) {
      setMobileMenuOpen(false);
    }
  });

  const syncHeaderMeasurements = () => {
    if (announcementBar) {
      root.style.setProperty("--announcement-bar-height", `${announcementBar.offsetHeight}px`);
    }
  };

  const updateHeaderMeasurements = () => {
    siteHeader.classList.remove("is-condensed");
    root.classList.remove("is-site-header-condensed");
    root.style.setProperty("--site-header-height", `${siteHeader.offsetHeight}px`);
    syncHeaderMeasurements();
  };

  updateHeaderMeasurements();
  window.addEventListener("load", updateHeaderMeasurements);
  window.addEventListener("resize", updateHeaderMeasurements);
}

const shopFilterToggle = document.querySelector("[data-shop-filter-toggle]");
const shopFilterBody = document.querySelector("[data-shop-filter-body]");
const shopFilterSidebar = shopFilterToggle?.closest(".shop-sidebar");

if (shopFilterToggle && shopFilterBody && shopFilterSidebar) {
  const mobileShopFilterQuery = window.matchMedia("(max-width: 699px)");

  const setShopFiltersOpen = (isOpen) => {
    const mobileOpen = mobileShopFilterQuery.matches && isOpen;
    shopFilterSidebar.classList.toggle("is-mobile-open", mobileOpen);
    shopFilterToggle.setAttribute("aria-expanded", String(mobileOpen));
    shopFilterBody.setAttribute("aria-hidden", String(mobileShopFilterQuery.matches && !mobileOpen));
  };

  shopFilterToggle.addEventListener("click", () => {
    setShopFiltersOpen(shopFilterToggle.getAttribute("aria-expanded") !== "true");
  });

  mobileShopFilterQuery.addEventListener("change", () => setShopFiltersOpen(false));
  setShopFiltersOpen(false);
}

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

(() => {
  const videoSelector = "[data-home-hero-video]";
  const controllers = new WeakMap();
  const getConnection = () => navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;

  const addMediaQueryListener = (query, listener) => {
    if (typeof query.addEventListener === "function") {
      query.addEventListener("change", listener);
      return () => query.removeEventListener("change", listener);
    }

    query.addListener(listener);
    return () => query.removeListener(listener);
  };

  const collectVideos = (scope) => {
    const videos = [];

    if (scope instanceof Element && scope.matches(videoSelector)) {
      videos.push(scope);
    }

    if (typeof scope.querySelectorAll === "function") {
      videos.push(...scope.querySelectorAll(videoSelector));
    }

    return videos;
  };

  const initializeVideo = (video) => {
    if (controllers.has(video)) {
      return;
    }

    const media = video.closest("[data-home-hero-media]");
    const manifest = media?.querySelector("[data-home-hero-sources]");
    let sources = [];

    try {
      sources = JSON.parse(manifest?.textContent || "[]")
        .filter((source) => source?.url)
        .map((source) => ({
          url: String(source.url),
          type: String(source.type || ""),
          format: String(source.format || "").toLowerCase(),
          width: Number(source.width) || 0,
          height: Number(source.height) || 0
        }));
    } catch (error) {
      sources = [];
    }

    if (!media || !sources.length) {
      return;
    }

    const desktopQuery = window.matchMedia("(min-width: 921px)");
    const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const connection = getConnection();
    const mp4Sources = sources
      .filter((source) => source.format === "mp4" || source.type.toLowerCase().includes("mp4"))
      .sort((sourceA, sourceB) => (sourceA.width * sourceA.height) - (sourceB.width * sourceB.height));
    const hlsSource = sources.find((source) => (
      source.format === "m3u8" || source.type.toLowerCase().includes("mpegurl")
    ));

    let selectedSource = null;
    let sourceAttached = false;
    let isIntersecting = !("IntersectionObserver" in window);
    let isDestroyed = false;
    let hasFailed = false;
    let hlsFailed = false;
    let startQueued = false;
    let loadTimeout = 0;
    let stallTimeout = 0;
    let idleCallback = 0;
    let startTimer = 0;
    let loadHandler = null;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;

    const clearPlaybackTimers = () => {
      window.clearTimeout(loadTimeout);
      window.clearTimeout(stallTimeout);
      loadTimeout = 0;
      stallTimeout = 0;
    };

    const connectionIsConstrained = () => {
      const effectiveType = connection?.effectiveType || "";
      return Boolean(connection?.saveData) || effectiveType === "slow-2g" || effectiveType === "2g";
    };

    const isEligible = () => desktopQuery.matches && !reducedMotionQuery.matches && !connectionIsConstrained();

    const supportsNativeHls = () => {
      if (!hlsSource || hlsFailed) {
        return false;
      }

      const sourceType = hlsSource.type || "application/vnd.apple.mpegurl";
      return Boolean(
        video.canPlayType(sourceType)
        || video.canPlayType("application/vnd.apple.mpegurl")
        || video.canPlayType("application/x-mpegURL")
      );
    };

    const selectMp4Source = () => {
      if (!mp4Sources.length) {
        return null;
      }

      const targetWidth = connection?.effectiveType === "3g" ? 1280 : 1920;
      const sourcesWithinTarget = mp4Sources.filter((source) => source.width > 0 && source.width <= targetWidth);
      return sourcesWithinTarget.at(-1) || mp4Sources[0];
    };

    const selectSource = () => (supportsNativeHls() ? hlsSource : selectMp4Source());

    const detachSource = () => {
      clearPlaybackTimers();
      sourceAttached = false;
      selectedSource = null;
      media.classList.remove("is-video-playing");
      video.pause();
      video.preload = "none";
      video.removeAttribute("src");
      video.removeAttribute("data-home-hero-selected-source");
      video.load();
    };

    const failToPoster = () => {
      hasFailed = true;
      detachSource();
    };

    const playIfAppropriate = () => {
      if (!sourceAttached || !isEligible() || !isIntersecting || document.hidden) {
        return;
      }

      if (!media.classList.contains("is-video-playing") && !loadTimeout) {
        loadTimeout = window.setTimeout(() => {
          if (!media.classList.contains("is-video-playing")) {
            failToPoster();
          }
        }, 8000);
      }

      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {
          if (sourceAttached && isIntersecting && !document.hidden) {
            failToPoster();
          }
        });
      }
    };

    const attachSource = () => {
      if (isDestroyed || sourceAttached || hasFailed || !isEligible() || !isIntersecting || document.hidden) {
        return;
      }

      const source = selectSource();

      if (!source) {
        failToPoster();
        return;
      }

      selectedSource = source;
      sourceAttached = true;
      video.src = source.url;
      video.dataset.homeHeroSelectedSource = `${source.format || "video"}-${source.width || "adaptive"}`;
      video.load();
      playIfAppropriate();
    };

    const queueSourceAttachment = () => {
      if (startQueued || sourceAttached || hasFailed || !isEligible() || !isIntersecting || document.hidden) {
        return;
      }

      startQueued = true;

      const run = () => {
        startQueued = false;
        idleCallback = 0;
        startTimer = 0;
        attachSource();
      };

      const queueAfterLoad = () => {
        loadHandler = null;

        if (typeof window.requestIdleCallback === "function") {
          idleCallback = window.requestIdleCallback(run, { timeout: 1500 });
        } else {
          startTimer = window.setTimeout(run, 250);
        }
      };

      if (document.readyState === "complete") {
        queueAfterLoad();
      } else {
        loadHandler = queueAfterLoad;
        window.addEventListener("load", loadHandler, { once: true });
      }
    };

    const evaluatePlayback = () => {
      if (isDestroyed) {
        return;
      }

      if (!isEligible()) {
        hasFailed = false;
        hlsFailed = false;
        detachSource();
        return;
      }

      if (!isIntersecting || document.hidden) {
        clearPlaybackTimers();
        video.pause();
        return;
      }

      if (sourceAttached) {
        playIfAppropriate();
      } else {
        queueSourceAttachment();
      }
    };

    const handlePlaying = () => {
      clearPlaybackTimers();
      media.classList.add("is-video-playing");
    };

    const handleWaiting = () => {
      if (!media.classList.contains("is-video-playing") || stallTimeout) {
        return;
      }

      const waitingAt = video.currentTime;

      stallTimeout = window.setTimeout(() => {
        stallTimeout = 0;

        const playbackAdvanced = video.currentTime > waitingAt + 0.25;
        const hasFutureData = video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA;

        if (
          !sourceAttached
          || !isEligible()
          || !isIntersecting
          || document.hidden
          || video.paused
          || video.ended
          || playbackAdvanced
          || hasFutureData
        ) {
          return;
        }

        failToPoster();
      }, 10000);
    };

    const handleSourceError = () => {
      if (!sourceAttached) {
        return;
      }

      const shouldTryMp4 = selectedSource === hlsSource && !hlsFailed && mp4Sources.length > 0;
      detachSource();

      if (shouldTryMp4) {
        hlsFailed = true;
        queueSourceAttachment();
      } else {
        hasFailed = true;
      }
    };

    // Native looping is seamless; this only catches non-conforming media implementations.
    const handleEnded = () => {
      video.currentTime = 0;
      playIfAppropriate();
    };

    const handleVisibilityChange = () => {
      evaluatePlayback();
    };

    const handleEligibilityChange = () => {
      hasFailed = false;
      evaluatePlayback();
    };

    video.addEventListener("playing", handlePlaying);
    video.addEventListener("waiting", handleWaiting);
    video.addEventListener("error", handleSourceError);
    video.addEventListener("ended", handleEnded);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    const removeDesktopListener = addMediaQueryListener(desktopQuery, handleEligibilityChange);
    const removeMotionListener = addMediaQueryListener(reducedMotionQuery, handleEligibilityChange);

    if (connection && typeof connection.addEventListener === "function") {
      connection.addEventListener("change", handleEligibilityChange);
    }

    const intersectionObserver = "IntersectionObserver" in window
      ? new IntersectionObserver((entries) => {
        const entry = entries[0];
        isIntersecting = Boolean(entry?.isIntersecting && entry.intersectionRatio >= 0.05);
        evaluatePlayback();
      }, { threshold: [0, 0.05] })
      : null;

    intersectionObserver?.observe(media);

    const destroy = () => {
      isDestroyed = true;
      detachSource();
      intersectionObserver?.disconnect();
      removeDesktopListener();
      removeMotionListener();

      if (connection && typeof connection.removeEventListener === "function") {
        connection.removeEventListener("change", handleEligibilityChange);
      }

      if (loadHandler) {
        window.removeEventListener("load", loadHandler);
      }

      if (idleCallback && typeof window.cancelIdleCallback === "function") {
        window.cancelIdleCallback(idleCallback);
      }

      window.clearTimeout(startTimer);
      video.removeEventListener("playing", handlePlaying);
      video.removeEventListener("waiting", handleWaiting);
      video.removeEventListener("error", handleSourceError);
      video.removeEventListener("ended", handleEnded);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      controllers.delete(video);
    };

    controllers.set(video, { destroy });
    evaluatePlayback();
  };

  const initializeVideos = (scope = document) => {
    collectVideos(scope).forEach(initializeVideo);
  };

  initializeVideos();

  document.addEventListener("shopify:section:load", (event) => initializeVideos(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    collectVideos(event.target).forEach((video) => controllers.get(video)?.destroy());
  });
})();

const homeHeroOdometer = document.querySelector("[data-home-odometer]");

if (homeHeroOdometer) {
  const homeHeroHeading = homeHeroOdometer.closest(".home-hero__heading");
  const targetValue = Number(homeHeroOdometer.dataset.target || 110);
  const formatOdometerValue = (value) => `${Math.round(Number(value) || 0)}`.padStart(3, "0");
  homeHeroHeading?.classList.add("is-garage-revealed");

  const setFinalValue = () => {
    homeHeroOdometer.textContent = formatOdometerValue(targetValue);
  };

  if (prefersReducedMotion) {
    setFinalValue();
  } else {
    const buildReel = ({ className, startDigit, targetDigit, cycles, duration, delay }) => {
      const totalSteps = (cycles * 10) + ((targetDigit - startDigit + 10) % 10);
      const digits = Array.from({ length: totalSteps + 1 }, (_, index) => (startDigit + index) % 10);
      const values = digits.map((digit) => `<span>${digit}</span>`).join("");

      return `
        <span class="home-hero__odometer-digit ${className}" aria-hidden="true">
          <span class="home-hero__odometer-wheel" style="--reel-final-index: ${digits.length - 1}; --reel-duration: ${duration}ms; --reel-delay: ${delay}ms;">${values}</span>
        </span>
      `;
    };

    homeHeroOdometer.classList.remove("odometer");
    homeHeroOdometer.classList.add("home-hero__odometer--custom");
    homeHeroOdometer.innerHTML = `
      ${buildReel({ className: "home-hero__odometer-digit--hundreds", startDigit: 4, targetDigit: 1, cycles: 4, duration: 2150, delay: 760 })}
      ${buildReel({ className: "home-hero__odometer-digit--tens", startDigit: 8, targetDigit: 1, cycles: 5, duration: 2380, delay: 720 })}
      ${buildReel({ className: "home-hero__odometer-digit--ones", startDigit: 5, targetDigit: 0, cycles: 6, duration: 2580, delay: 680 })}
    `;
    homeHeroOdometer.setAttribute("aria-label", formatOdometerValue(targetValue));
  }
}

const centeredStickyPanels = Array.from(document.querySelectorAll(".shop-sidebar, .shop-vehicle-sidebar, .brands-sidebar, .brands-progress-sidebar"));

if (centeredStickyPanels.length) {
  let centeredStickyFrame = 0;

  const updateCenteredStickyPanels = () => {
    centeredStickyFrame = 0;
    const maxOffset = Math.max(0, (window.innerHeight / 2) - 16);

    centeredStickyPanels.forEach((panel) => {
      const centerOffset = Math.min(panel.offsetHeight / 2, maxOffset);
      panel.style.setProperty("--sticky-center-offset", `${centerOffset}px`);
    });
  };

  const scheduleCenteredStickyUpdate = () => {
    if (centeredStickyFrame) {
      return;
    }

    centeredStickyFrame = window.requestAnimationFrame(updateCenteredStickyPanels);
  };

  if ("ResizeObserver" in window) {
    const centeredStickyObserver = new ResizeObserver(scheduleCenteredStickyUpdate);
    centeredStickyPanels.forEach((panel) => centeredStickyObserver.observe(panel));
  }

  scheduleCenteredStickyUpdate();
  window.addEventListener("load", scheduleCenteredStickyUpdate);
  window.addEventListener("resize", scheduleCenteredStickyUpdate);
}

const supplierLogoMarquees = Array.from(document.querySelectorAll(".supplier-logo-marquee"));

if (supplierLogoMarquees.length && !prefersReducedMotion) {
  const setMarqueeSpeed = (track, rate) => {
    const animations = typeof track.getAnimations === "function" ? track.getAnimations() : [];

    if (!animations.length) {
      track.style.setProperty("--supplier-marquee-duration", rate < 1 ? "190s" : "82s");
      return;
    }

    animations.forEach((animation) => {
      if (typeof animation.updatePlaybackRate === "function") {
        animation.updatePlaybackRate(rate);
      } else {
        animation.playbackRate = rate;
      }
    });
  };

  supplierLogoMarquees.forEach((marquee) => {
    const tracks = Array.from(marquee.querySelectorAll(".supplier-logo-marquee__track"));

    if (!tracks.length) {
      return;
    }

    marquee.addEventListener("pointerenter", () => tracks.forEach((track) => setMarqueeSpeed(track, 0.22)));
    marquee.addEventListener("pointerleave", () => tracks.forEach((track) => setMarqueeSpeed(track, 1)));
    marquee.addEventListener("focusin", () => tracks.forEach((track) => setMarqueeSpeed(track, 0.22)));
    marquee.addEventListener("focusout", () => {
      if (!marquee.contains(document.activeElement)) {
        tracks.forEach((track) => setMarqueeSpeed(track, 1));
      }
    });
  });
}

const pressableControlSelector = [
  "button:not(:disabled)",
  "a.button",
  ".home-landing__cta",
  ".site-header__quick-link",
  ".site-header__nav a",
  ".supply-list__link",
  ".shop-filter-option",
  ".shop-diameter-option"
].join(", ");
const pressedControlClass = "is-control-pressed";
const releasingControlClass = "is-control-releasing";
const controlReleaseTimers = new WeakMap();
let activePressControl = null;
let activePressSource = "";

const pressableControlFor = (target) => {
  const control = target instanceof Element ? target.closest(pressableControlSelector) : null;

  if (!control || control.matches(":disabled, [aria-disabled='true']")) {
    return null;
  }

  return control;
};

const clearControlRelease = (control) => {
  const timer = controlReleaseTimers.get(control);

  if (timer) {
    window.clearTimeout(timer);
    controlReleaseTimers.delete(control);
  }

  control.classList.remove(releasingControlClass);
};

const playControlRelease = (control) => {
  clearControlRelease(control);

  if (prefersReducedMotion) {
    return;
  }

  // Restart the animation for rapid repeat clicks without touching transform-based hover states.
  void control.offsetWidth;
  control.classList.add(releasingControlClass);
  controlReleaseTimers.set(control, window.setTimeout(() => clearControlRelease(control), 420));
};

const beginControlPress = (control, source) => {
  if (activePressControl && activePressControl !== control) {
    activePressControl.classList.remove(pressedControlClass);
  }

  clearControlRelease(control);
  control.classList.add(pressedControlClass);
  activePressControl = control;
  activePressSource = source;
};

const endControlPress = (source, animate = true) => {
  if (!activePressControl || activePressSource !== source) {
    return null;
  }

  const control = activePressControl;
  activePressControl = null;
  activePressSource = "";
  control.classList.remove(pressedControlClass);

  if (animate) {
    playControlRelease(control);
  }

  return control;
};

const cancelControlPress = () => {
  if (activePressControl) {
    activePressControl.classList.remove(pressedControlClass);
  }

  activePressControl = null;
  activePressSource = "";
};

document.addEventListener("pointerdown", (event) => {
  const control = pressableControlFor(event.target);

  if (!control || event.button !== 0) {
    return;
  }

  beginControlPress(control, "pointer");
});

document.addEventListener("pointerup", () => endControlPress("pointer"));
document.addEventListener("pointercancel", cancelControlPress);

document.addEventListener("keydown", (event) => {
  if (event.repeat || (event.key !== "Enter" && event.key !== " ")) {
    return;
  }

  const control = pressableControlFor(event.target);

  if (control) {
    beginControlPress(control, "keyboard");
  }
});

document.addEventListener("keyup", (event) => {
  if (event.key === "Enter" || event.key === " ") {
    endControlPress("keyboard");
  }
});

document.addEventListener("animationend", (event) => {
  if (event.animationName !== "control-release-pop" && event.animationName !== "home-shopping-cta-release") {
    return;
  }

  const control = event.target instanceof Element ? event.target.closest(`.${releasingControlClass}`) : null;

  if (control) {
    clearControlRelease(control);
  }
});

window.addEventListener("blur", cancelControlPress);

document.addEventListener("click", (event) => {
  const link = event.target instanceof Element ? event.target.closest(".home-landing__cta") : null;

  if (
    !link ||
    event.defaultPrevented ||
    prefersReducedMotion ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    link.hasAttribute("download") ||
    (link.target && link.target !== "_self")
  ) {
    return;
  }

  const destination = new URL(link.href, window.location.href);

  if (destination.origin !== window.location.origin) {
    return;
  }

  event.preventDefault();

  if (link.dataset.pressNavigationPending === "true") {
    return;
  }

  link.dataset.pressNavigationPending = "true";

  if (activePressControl === link) {
    endControlPress(activePressSource);
  } else if (!link.classList.contains(releasingControlClass)) {
    playControlRelease(link);
  }

  // Let the metal plate finish its restrained release before following the link.
  window.setTimeout(() => window.location.assign(destination.href), 170);
});

const catalogShop = document.querySelector("[data-catalog-shop]");
const fitmentConfig = window.fitmentConfig || {};
const fitmentStorageKey = fitmentConfig.storageKey || "110GarageFitmentVehicle";
const fitmentProxyBase = String(fitmentConfig.proxyUrl || "").trim().replace(/\/+$/, "");
const isLocalFitmentPreview = ["localhost", "127.0.0.1"].includes(window.location.hostname);

const fitmentCleanText = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value).replace(/\s+/g, " ").trim();
};

const fitmentListText = (value, fallback = "Not listed") => {
  const values = Array.isArray(value) ? value : [value];
  const text = values.map(fitmentCleanText).filter(Boolean).join(", ");
  return text || fallback;
};

const fitmentReadStored = () => {
  try {
    const raw = window.localStorage?.getItem(fitmentStorageKey);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const fitmentWriteStored = (record) => {
  try {
    window.localStorage?.setItem(fitmentStorageKey, JSON.stringify(record));
  } catch {
    // Storage can be unavailable in strict privacy modes.
  }

  window.dispatchEvent(new CustomEvent("fitment:change", { detail: { record } }));
};

const fitmentClearStored = () => {
  try {
    window.localStorage?.removeItem(fitmentStorageKey);
  } catch {
    // Storage can be unavailable in strict privacy modes.
  }

  window.dispatchEvent(new CustomEvent("fitment:change", { detail: { record: null } }));
};

const fitmentVehicleLabel = (record, includeModification = true) => {
  const vehicle = record?.vehicle || {};
  const baseLabel = [
    vehicle.year,
    vehicle.make?.label || vehicle.make?.name,
    vehicle.model?.label || vehicle.model?.name
  ].map(fitmentCleanText).filter(Boolean).join(" ");
  const modificationLabel = fitmentCleanText(vehicle.modification?.label || vehicle.modification?.name);

  if (includeModification && modificationLabel) {
    return [baseLabel, modificationLabel].filter(Boolean).join(" - ");
  }

  return baseLabel || fitmentCleanText(record?.label);
};

const fitmentSummaryForRecord = (record) => {
  const fitment = record?.fitment || {};

  return {
    vehicle: fitmentVehicleLabel(record),
    modification: fitmentCleanText(record?.vehicle?.modification?.label || record?.vehicle?.modification?.name),
    boltPattern: fitmentCleanText(fitment.boltPattern),
    centreBore: fitmentCleanText(fitment.centreBore || fitment.centerBore),
    wheelSizes: fitmentListText(fitment.wheelSizes, ""),
    tyreSizes: fitmentListText(fitment.tyreSizes || fitment.tireSizes, ""),
    offsets: fitmentListText(fitment.offsets, ""),
    source: fitmentCleanText(record?.source || "Wheel-Size v2")
  };
};

const fitmentContactUrl = (record) => {
  const summary = fitmentSummaryForRecord(record);
  const vehicle = record?.vehicle || {};
  const params = new URLSearchParams();

  params.set("fitmentVehicle", summary.vehicle);
  params.set("fitmentModification", summary.modification);
  params.set("fitmentBoltPattern", summary.boltPattern);
  params.set("fitmentCenterBore", summary.centreBore);
  params.set("fitmentWheelSizes", summary.wheelSizes);
  params.set("fitmentTyreSizes", summary.tyreSizes);
  params.set("fitmentOffsets", summary.offsets);
  params.set("fitmentSource", summary.source);
  params.set("vehicleYear", fitmentCleanText(vehicle.year));
  params.set("vehicleMake", fitmentCleanText(vehicle.make?.label || vehicle.make?.name));
  params.set("vehicleModel", fitmentCleanText(vehicle.model?.label || vehicle.model?.name));

  Array.from(params.entries()).forEach(([key, value]) => {
    if (!value) {
      params.delete(key);
    }
  });

  return `/pages/contact?${params.toString()}`;
};

const fitmentModal = document.querySelector("[data-fitment-modal]");
const fitmentModalTriggers = Array.from(document.querySelectorAll("[data-fitment-modal-open]"));
const fitmentShopCard = document.querySelector("[data-fitment-shop-card]");
let fitmentModalOpener = null;

const syncFitmentSurfaces = (record = fitmentReadStored()) => {
  const summary = record ? fitmentSummaryForRecord(record) : null;

  fitmentModalTriggers.forEach((trigger) => {
    trigger.classList.toggle("has-vehicle", Boolean(record));
    trigger.setAttribute("aria-label", record ? `Change vehicle: ${fitmentVehicleLabel(record)}` : "Add your vehicle");
    const label = trigger.querySelector("[data-fitment-trigger-label]");

    if (label) {
      label.textContent = record ? "My vehicle" : "Add vehicle";
    }
  });

  if (!fitmentShopCard) {
    return;
  }

  const emptyPanel = fitmentShopCard.querySelector("[data-fitment-shop-empty]");
  const summaryPanel = fitmentShopCard.querySelector("[data-fitment-shop-summary]");
  emptyPanel.hidden = Boolean(record);
  summaryPanel.hidden = !record;
  fitmentShopCard.classList.toggle("has-vehicle", Boolean(record));

  if (!record || !summary) {
    return;
  }

  const title = fitmentShopCard.querySelector("[data-fitment-shop-title]");
  const variant = fitmentShopCard.querySelector("[data-fitment-shop-variant]");
  const bolt = fitmentShopCard.querySelector("[data-fitment-shop-bolt]");
  const wheels = fitmentShopCard.querySelector("[data-fitment-shop-wheels]");

  if (title) title.textContent = fitmentVehicleLabel(record, false) || "Selected vehicle";
  if (variant) variant.textContent = summary.modification.replace(/\s+-\s+/g, " / ");
  if (bolt) bolt.textContent = summary.boltPattern || "Not listed";
  if (wheels) wheels.textContent = summary.wheelSizes || "Not listed";
};

const closeFitmentModal = () => {
  if (!fitmentModal?.open) {
    return;
  }

  fitmentModal.close();
};

const openFitmentModal = (opener) => {
  if (!fitmentModal || typeof fitmentModal.showModal !== "function") {
    return;
  }

  const menuToggle = siteHeader?.querySelector("[data-mobile-menu-toggle]");

  if (menuToggle?.getAttribute("aria-expanded") === "true") {
    menuToggle.click();
  }

  fitmentModalOpener = opener || document.activeElement;
  fitmentModal.showModal();
  body.classList.add("has-fitment-modal-open");
  fitmentModal.querySelector("[data-fitment-lookup]")?.ensureReady?.().catch?.(() => {});
  window.requestAnimationFrame(() => {
    fitmentModal.querySelector("select:not([disabled]), button:not([disabled])")?.focus({ preventScroll: true });
  });
};

fitmentModalTriggers.forEach((trigger) => {
  trigger.addEventListener("click", () => openFitmentModal(trigger));
});

fitmentModal?.querySelector("[data-fitment-modal-close]")?.addEventListener("click", closeFitmentModal);
fitmentModal?.addEventListener("click", (event) => {
  if (event.target === fitmentModal) {
    closeFitmentModal();
  }
});
fitmentModal?.addEventListener("close", () => {
  body.classList.remove("has-fitment-modal-open");
  fitmentModalOpener?.focus?.({ preventScroll: true });
  fitmentModalOpener = null;
});

window.addEventListener("fitment:change", (event) => syncFitmentSurfaces(event.detail?.record || null));
window.addEventListener("storage", (event) => {
  if (event.key === fitmentStorageKey) {
    const record = fitmentReadStored();
    syncFitmentSurfaces(record);
    window.dispatchEvent(new CustomEvent("fitment:change", { detail: { record } }));
  }
});
syncFitmentSurfaces();

const fitmentLookup = document.querySelector("[data-fitment-lookup]");

if (fitmentLookup) {
  const yearSelect = fitmentLookup.querySelector("[data-fitment-year]");
  const makeSelect = fitmentLookup.querySelector("[data-fitment-make]");
  const modelSelect = fitmentLookup.querySelector("[data-fitment-model]");
  const modificationSelect = fitmentLookup.querySelector("[data-fitment-modification]");
  const headerPanel = fitmentLookup.querySelector(".fitment-lookup__header");
  const controlsPanel = fitmentLookup.querySelector(".fitment-lookup__controls");
  let expandButton = fitmentLookup.querySelector("[data-fitment-expand]");
  const searchButton = fitmentLookup.querySelector("[data-fitment-search]");
  const clearButton = fitmentLookup.querySelector("[data-fitment-clear]");
  const status = fitmentLookup.querySelector("[data-fitment-status]");
  const summaryPanel = fitmentLookup.querySelector("[data-fitment-summary]");
  const summaryTitle = fitmentLookup.querySelector("[data-fitment-summary-title]");
  const summaryVariant = fitmentLookup.querySelector("[data-fitment-summary-variant]");
  const boltPatternText = fitmentLookup.querySelector("[data-fitment-bolt-pattern]");
  const centreBoreText = fitmentLookup.querySelector("[data-fitment-centre-bore]");
  const wheelSizesText = fitmentLookup.querySelector("[data-fitment-wheel-sizes]");
  const tyreSizesText = fitmentLookup.querySelector("[data-fitment-tyre-sizes]");
  const offsetsText = fitmentLookup.querySelector("[data-fitment-offsets]");
  const vehicleSidebar = fitmentLookup.closest(".shop-vehicle-sidebar");
  const fitmentIsModal = Boolean(fitmentLookup.closest("[data-fitment-modal]"));
  const selects = [yearSelect, makeSelect, modelSelect, modificationSelect].filter(Boolean);
  let fitmentPickerExpanded = fitmentIsModal;
  let fitmentPickerHydrated = false;
  let fitmentPickerHydrationPromise = null;

  fitmentLookup.querySelector(".fitment-lookup__kicker")?.remove();

  if (headerPanel && !fitmentLookup.querySelector(".fitment-lookup__intro")) {
    const heading = headerPanel.querySelector("h2");
    const intro = document.createElement("p");
    intro.className = "fitment-lookup__intro";
    intro.dataset.fitmentIntro = "";
    intro.textContent = "Enter your vehicle to get recommendations on selected rim products.";
    heading?.insertAdjacentElement("afterend", intro);
  }

  if (!expandButton && !fitmentIsModal) {
    expandButton = document.createElement("button");
    expandButton.className = "button fitment-lookup__expand";
    expandButton.type = "button";
    expandButton.dataset.fitmentExpand = "";
    expandButton.textContent = "Find my vehicle";
    headerPanel?.insertAdjacentElement("afterend", expandButton);
  }

  if (!fitmentIsModal) {
    fitmentLookup.classList.add("has-fitment-expand");
  }

  const expandFitmentPicker = () => {
    fitmentPickerExpanded = true;
    renderFitmentSummary(fitmentReadStored());
    updateFitmentExpandedState();
    fitmentLookup.ensureReady?.();
    yearSelect?.focus({ preventScroll: true });
  };

  const setFitmentStatus = (message, type = "notice") => {
    if (!status) {
      return;
    }

    status.textContent = message || "";
    status.dataset.statusType = type;
  };

  const optionFromSelect = (select) => {
    const option = select?.selectedOptions?.[0];
    return {
      value: fitmentCleanText(select?.value),
      label: fitmentCleanText(option?.textContent)
    };
  };

  const resetSelect = (select, placeholder) => {
    if (!select) {
      return;
    }

    select.classList.remove("is-loading");
    select.innerHTML = "";
    const placeholderOption = document.createElement("option");
    placeholderOption.value = "";
    placeholderOption.textContent = placeholder;
    select.append(placeholderOption);
    select.disabled = true;
  };

  const setSelectLoading = (select, label) => {
    if (!select) {
      return;
    }

    select.innerHTML = "";
    const loadingOption = document.createElement("option");
    loadingOption.value = "";
    loadingOption.textContent = label;
    select.append(loadingOption);
    select.disabled = true;
    select.classList.add("is-loading");
  };

  const populateSelect = (select, placeholder, items, preferredValue = "") => {
    resetSelect(select, placeholder);
    select.classList.remove("is-loading");

    items.forEach((item) => {
      const option = document.createElement("option");
      option.value = fitmentCleanText(item.value || item.slug);
      option.textContent = fitmentCleanText(item.label || item.name || item.slug || item.value);
      select.append(option);
    });

    select.disabled = !items.length;

    if (preferredValue && Array.from(select.options).some((option) => option.value === preferredValue)) {
      select.value = preferredValue;
    }
  };

  const updateSearchState = () => {
    if (!searchButton) {
      return;
    }

    searchButton.disabled = !selects.every((select) => fitmentCleanText(select.value));
  };

  const updateFitmentExpandedState = () => {
    const hasStoredVehicle = Boolean(fitmentReadStored());
    fitmentLookup.classList.toggle("is-fitment-collapsed", !hasStoredVehicle && !fitmentPickerExpanded);
    fitmentLookup.classList.toggle("is-fitment-expanded", !hasStoredVehicle && fitmentPickerExpanded);

    if (controlsPanel) {
      controlsPanel.hidden = hasStoredVehicle || !fitmentPickerExpanded;
    }

    if (expandButton) {
      expandButton.hidden = hasStoredVehicle || fitmentPickerExpanded;
    }
  };

  const renderFitmentSummary = (record) => {
    if (!record || !summaryPanel) {
      if (summaryPanel) {
        summaryPanel.hidden = true;
      }

      if (controlsPanel) {
        controlsPanel.hidden = !fitmentPickerExpanded;
      }

      fitmentLookup.classList.remove("is-vehicle-stored");
      vehicleSidebar?.classList.remove("is-vehicle-stored");
      updateFitmentExpandedState();
      return;
    }

    const summary = fitmentSummaryForRecord(record);
    summaryPanel.hidden = false;
    fitmentLookup.classList.add("is-vehicle-stored");
    vehicleSidebar?.classList.add("is-vehicle-stored");

    if (controlsPanel) {
      controlsPanel.hidden = true;
    }

    if (expandButton) {
      expandButton.hidden = true;
    }

    if (summaryTitle) {
      summaryTitle.textContent = fitmentVehicleLabel(record, false) || "Selected vehicle";
    }

    if (summaryVariant) {
      const variant = summary.modification.replace(/\s+-\s+/g, " / ");
      summaryVariant.textContent = variant;
      summaryVariant.hidden = !variant;
    }

    if (boltPatternText) {
      boltPatternText.textContent = summary.boltPattern || "Not listed";
    }

    if (centreBoreText) {
      centreBoreText.textContent = summary.centreBore || "Not listed";
    }

    if (wheelSizesText) {
      wheelSizesText.textContent = summary.wheelSizes || "Not listed";
    }

    if (tyreSizesText) {
      tyreSizesText.textContent = summary.tyreSizes || "Not listed";
    }

    if (offsetsText) {
      offsetsText.textContent = summary.offsets || "Not listed";
    }

  };

  const fitmentFetch = async (endpoint, params = {}) => {
    const url = new URL(`${fitmentProxyBase}/api/fitment/${endpoint}`);

    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        url.searchParams.set(key, value);
      }
    });

    if (fitmentConfig.region) {
      url.searchParams.set("region", fitmentConfig.region);
    }

    const response = await fetch(url.toString(), {
      cache: "no-store",
      headers: {
        Accept: "application/json"
      }
    });
    const payload = await response.json().catch(() => ({}));

    if (!response.ok || payload.ok === false) {
      throw new Error(payload.message || "Vehicle lookup is unavailable.");
    }

    return payload;
  };

  const loadYears = async (preferredValue = "") => {
    setSelectLoading(yearSelect, "Loading years...");

    try {
      const payload = await fitmentFetch("years");
      populateSelect(yearSelect, "Year", payload.data || [], preferredValue);
      setFitmentStatus("");
      updateSearchState();
    } catch (error) {
      resetSelect(yearSelect, "Year");
      throw error;
    }
  };

  const loadMakes = async (preferredValue = "") => {
    setSelectLoading(makeSelect, "Loading makes...");
    resetSelect(modelSelect, "Model");
    resetSelect(modificationSelect, "Variant");
    updateSearchState();

    if (!yearSelect?.value) {
      resetSelect(makeSelect, "Make");
      return;
    }

    try {
      const payload = await fitmentFetch("makes", { year: yearSelect.value });
      populateSelect(makeSelect, "Make", payload.data || [], preferredValue);
      setFitmentStatus("");
      updateSearchState();
    } catch (error) {
      resetSelect(makeSelect, "Make");
      throw error;
    }
  };

  const loadModels = async (preferredValue = "") => {
    setSelectLoading(modelSelect, "Loading models...");
    resetSelect(modificationSelect, "Variant");
    updateSearchState();

    if (!yearSelect?.value || !makeSelect?.value) {
      resetSelect(modelSelect, "Model");
      return;
    }

    try {
      const payload = await fitmentFetch("models", {
        year: yearSelect.value,
        make: makeSelect.value
      });
      populateSelect(modelSelect, "Model", payload.data || [], preferredValue);
      setFitmentStatus("");
      updateSearchState();
    } catch (error) {
      resetSelect(modelSelect, "Model");
      throw error;
    }
  };

  const loadModifications = async (preferredValue = "") => {
    setSelectLoading(modificationSelect, "Loading variants...");
    updateSearchState();

    if (!yearSelect?.value || !makeSelect?.value || !modelSelect?.value) {
      resetSelect(modificationSelect, "Variant");
      return;
    }

    try {
      const payload = await fitmentFetch("modifications", {
        year: yearSelect.value,
        make: makeSelect.value,
        model: modelSelect.value
      });
      populateSelect(modificationSelect, "Variant", payload.data || [], preferredValue);
      setFitmentStatus("");
      updateSearchState();
    } catch (error) {
      resetSelect(modificationSelect, "Variant");
      throw error;
    }
  };

  const searchFitment = async () => {
    if (!selects.every((select) => fitmentCleanText(select.value))) {
      updateSearchState();
      return;
    }

    searchButton.disabled = true;
    setFitmentStatus("Checking specs...");

    try {
      const payload = await fitmentFetch("search", {
        year: yearSelect.value,
        make: makeSelect.value,
        model: modelSelect.value,
        modification: modificationSelect.value
      });
      const record = {
        selectedAt: new Date().toISOString(),
        source: "Wheel-Size v2",
        vehicle: {
          year: yearSelect.value,
          make: optionFromSelect(makeSelect),
          model: optionFromSelect(modelSelect),
          modification: optionFromSelect(modificationSelect)
        },
        fitment: payload.fitment || payload.data?.[0]?.fitment || {}
      };

      fitmentWriteStored(record);
      renderFitmentSummary(record);
      setFitmentStatus("Vehicle saved.", "success");
    } catch (error) {
      setFitmentStatus(error.message || "Vehicle lookup failed. Send an enquiry and we can confirm it manually.", "warning");
    } finally {
      updateSearchState();
    }
  };

  fitmentLookup.openInlinePicker = async (host) => {
    if (!host || !controlsPanel) {
      return;
    }

    const controls = controlsPanel.cloneNode(true);
    controls.hidden = false;
    controls.classList.add("fitment-lookup__controls--inline");
    const inlineYear = controls.querySelector("[data-fitment-year]");
    const inlineMake = controls.querySelector("[data-fitment-make]");
    const inlineModel = controls.querySelector("[data-fitment-model]");
    const inlineModification = controls.querySelector("[data-fitment-modification]");
    const inlineSearch = controls.querySelector("[data-fitment-search]");
    const inlineSelects = [inlineYear, inlineMake, inlineModel, inlineModification];
    const inlineStatus = document.createElement("p");
    inlineStatus.className = "catalog-product-detail__vehicle-picker-status";
    inlineStatus.setAttribute("aria-live", "polite");
    inlineStatus.setAttribute("aria-atomic", "true");

    host.replaceChildren(controls, inlineStatus);
    host.hidden = false;

    const setInlineStatus = (message, type = "notice") => {
      inlineStatus.textContent = message || "";
      inlineStatus.dataset.statusType = type;
    };
    const updateInlineSearch = () => {
      inlineSearch.disabled = !inlineSelects.every((select) => fitmentCleanText(select?.value));
    };
    const loadInlineYears = async (preferredValue = "") => {
      setSelectLoading(inlineYear, "Loading years...");
      const payload = await fitmentFetch("years");
      populateSelect(inlineYear, "Year", payload.data || [], preferredValue);
      updateInlineSearch();
    };
    const loadInlineMakes = async (preferredValue = "") => {
      setSelectLoading(inlineMake, "Loading makes...");
      resetSelect(inlineModel, "Model");
      resetSelect(inlineModification, "Variant");
      const payload = await fitmentFetch("makes", { year: inlineYear.value });
      populateSelect(inlineMake, "Make", payload.data || [], preferredValue);
      updateInlineSearch();
    };
    const loadInlineModels = async (preferredValue = "") => {
      setSelectLoading(inlineModel, "Loading models...");
      resetSelect(inlineModification, "Variant");
      const payload = await fitmentFetch("models", { year: inlineYear.value, make: inlineMake.value });
      populateSelect(inlineModel, "Model", payload.data || [], preferredValue);
      updateInlineSearch();
    };
    const loadInlineModifications = async (preferredValue = "") => {
      setSelectLoading(inlineModification, "Loading variants...");
      const payload = await fitmentFetch("modifications", {
        year: inlineYear.value,
        make: inlineMake.value,
        model: inlineModel.value
      });
      populateSelect(inlineModification, "Variant", payload.data || [], preferredValue);
      updateInlineSearch();
    };

    inlineYear.addEventListener("change", () => {
      loadInlineMakes().then(() => setInlineStatus("")).catch(() => setInlineStatus("Could not load makes for that year.", "warning"));
    });
    inlineMake.addEventListener("change", () => {
      loadInlineModels().then(() => setInlineStatus("")).catch(() => setInlineStatus("Could not load models for that make.", "warning"));
    });
    inlineModel.addEventListener("change", () => {
      loadInlineModifications().then(() => setInlineStatus("")).catch(() => setInlineStatus("Could not load variants for that model.", "warning"));
    });
    inlineModification.addEventListener("change", updateInlineSearch);
    inlineSearch.addEventListener("click", async () => {
      if (!inlineSelects.every((select) => fitmentCleanText(select.value))) {
        updateInlineSearch();
        return;
      }

      inlineSearch.disabled = true;
      setInlineStatus("Checking specs...");

      try {
        const payload = await fitmentFetch("search", {
          year: inlineYear.value,
          make: inlineMake.value,
          model: inlineModel.value,
          modification: inlineModification.value
        });
        const record = {
          selectedAt: new Date().toISOString(),
          source: "Wheel-Size v2",
          vehicle: {
            year: inlineYear.value,
            make: optionFromSelect(inlineMake),
            model: optionFromSelect(inlineModel),
            modification: optionFromSelect(inlineModification)
          },
          fitment: payload.fitment || payload.data?.[0]?.fitment || {}
        };

        fitmentWriteStored(record);
        setInlineStatus("Vehicle saved.", "success");
      } catch (error) {
        setInlineStatus(error.message || "Vehicle lookup failed.", "warning");
        updateInlineSearch();
      }
    });

    inlineSelects.forEach((select, index) => resetSelect(select, ["Year", "Make", "Model", "Variant"][index]));

    if (!fitmentProxyBase) {
      setInlineStatus("Vehicle lookup is unavailable. Send an enquiry and 110 Garage can confirm it manually.", "warning");
      return;
    }

    const stored = fitmentReadStored();

    try {
      await loadInlineYears(stored?.vehicle?.year || "");
      if (stored?.vehicle?.year) await loadInlineMakes(stored.vehicle.make?.value || "");
      if (stored?.vehicle?.make?.value) await loadInlineModels(stored.vehicle.model?.value || "");
      if (stored?.vehicle?.model?.value) await loadInlineModifications(stored.vehicle.modification?.value || "");
      setInlineStatus("");
    } catch {
      setInlineStatus("Vehicle lookup is unavailable. Send an enquiry and 110 Garage can confirm it manually.", "warning");
    }
  };

  const resetFitmentPicker = () => {
    if (yearSelect) {
      yearSelect.value = "";
      yearSelect.disabled = yearSelect.options.length <= 1;
    }

    resetSelect(makeSelect, "Make");
    resetSelect(modelSelect, "Model");
    resetSelect(modificationSelect, "Variant");
    updateSearchState();
  };

  const hydrateStoredFitment = async () => {
    const stored = fitmentReadStored();

    if (!stored?.vehicle) {
      return;
    }

    renderFitmentSummary(stored);

    try {
      if (stored.vehicle.year) {
        yearSelect.value = stored.vehicle.year;
        await loadMakes(stored.vehicle.make?.value);
      }

      if (stored.vehicle.make?.value) {
        await loadModels(stored.vehicle.model?.value);
      }

      if (stored.vehicle.model?.value) {
        await loadModifications(stored.vehicle.modification?.value);
      }
    } catch {
      updateSearchState();
    }
  };

  window.addEventListener("fitment:change", (event) => {
    renderFitmentSummary(event.detail?.record || null);
  });

  if (!fitmentProxyBase) {
    if (isLocalFitmentPreview) {
      fitmentLookup.hidden = false;
      resetSelect(yearSelect, "Year");
      resetSelect(makeSelect, "Make");
      resetSelect(modelSelect, "Model");
      resetSelect(modificationSelect, "Variant");
      renderFitmentSummary(fitmentReadStored());
      setFitmentStatus("Add the Cloudflare Worker URL in theme settings to enable lookup.", "warning");
    } else {
      fitmentLookup.hidden = true;
    }
  } else {
    fitmentLookup.hidden = false;
    resetSelect(yearSelect, "Year");
    resetSelect(makeSelect, "Make");
    resetSelect(modelSelect, "Model");
    resetSelect(modificationSelect, "Variant");
    renderFitmentSummary(fitmentReadStored());

    fitmentLookup.ensureReady = () => {
      if (fitmentPickerHydrated) {
        return Promise.resolve();
      }

      if (!fitmentPickerHydrationPromise) {
        fitmentPickerHydrationPromise = loadYears(fitmentReadStored()?.vehicle?.year)
          .then(hydrateStoredFitment)
          .then(() => {
            fitmentPickerHydrated = true;
          })
          .catch((error) => {
            fitmentPickerHydrationPromise = null;
            setFitmentStatus("Vehicle lookup is unavailable. Send an enquiry and we can confirm it manually.", "warning");
            throw error;
          });
      }

      return fitmentPickerHydrationPromise;
    };

    yearSelect?.addEventListener("change", () => {
      loadMakes().catch(() => {
        setFitmentStatus("Could not load makes for that year.", "warning");
      });
    });

    makeSelect?.addEventListener("change", () => {
      loadModels().catch(() => {
        setFitmentStatus("Could not load models for that make.", "warning");
      });
    });

    modelSelect?.addEventListener("change", () => {
      loadModifications().catch(() => {
        setFitmentStatus("Could not load variants for that model.", "warning");
      });
    });

    modificationSelect?.addEventListener("change", updateSearchState);
    searchButton?.addEventListener("click", searchFitment);
    clearButton?.addEventListener("click", () => {
      fitmentClearStored();
      fitmentPickerExpanded = true;
      renderFitmentSummary(null);
      resetFitmentPicker();
      setFitmentStatus("Vehicle specs cleared.");
    });

    expandButton?.addEventListener("click", expandFitmentPicker);
    fitmentLookup.addEventListener("click", (event) => {
      if (!fitmentLookup.classList.contains("is-fitment-collapsed")) {
        return;
      }

      if (event.target.closest("button, a, select, input, textarea")) {
        return;
      }

      expandFitmentPicker();
    });
  }
}

if (catalogShop && window.catalogData) {
  const data = window.catalogData;
  const details = window.catalogDetails || {};
  const wheelFitmentSpecs = window.wheelFitmentSpecs || {};
  const wheelSpecRowsByKey = wheelFitmentSpecs.productsByKey || {};
  const wheelSpecCoverageByKey = wheelFitmentSpecs.coverageByKey || {};
  const wheelSpecRangesByKey = wheelFitmentSpecs.rangesByKey || {};
  const searchInput = catalogShop.querySelector("[data-catalog-search]");
  const brandSelect = catalogShop.querySelector("[data-catalog-brand]");
  const brandResetButton = catalogShop.querySelector("[data-catalog-brand-reset]");
  const filtersResetButton = catalogShop.querySelector("[data-catalog-filters-reset]");
  const wheelDiameterOptions = catalogShop.querySelector("[data-catalog-wheel-diameters]");
  const boltPatternSelect = catalogShop.querySelector("[data-catalog-bolt-pattern]");
  const wheelSpecFilterGroup = catalogShop.querySelector("[data-catalog-wheel-spec-filters]");
  const activeBrandLabel = catalogShop.querySelector("[data-catalog-active-brand]");
  const categoryButtons = Array.from(catalogShop.querySelectorAll("[data-catalog-category]"));
  const subcategoryButtons = Array.from(catalogShop.querySelectorAll("[data-catalog-subcategory]"));
  const subcategoryGroups = Array.from(catalogShop.querySelectorAll("[data-catalog-subcategory-group]"));
  const brandStrip = catalogShop.querySelector("[data-catalog-brand-strip]");
  const grid = catalogShop.querySelector("[data-catalog-grid]");
  const count = catalogShop.querySelector("[data-catalog-count]");
  const empty = catalogShop.querySelector("[data-catalog-empty]");
  const pagination = catalogShop.querySelector("[data-catalog-pagination]");
  const shopWorkspace = catalogShop.querySelector(".shop-workspace");
  const shopHero = catalogShop.querySelector(".shop-hero");
  // Keep coming-soon categories selectable so their heading and empty state remain useful,
  // without publishing provisional product cards before the final catalogue is ready.
  const comingSoonCatalogCategories = new Set(["Accessories"]);
  const publishedCatalogGroups = (data.groups || []).filter((group) => !comingSoonCatalogCategories.has(group.category));
  const allBrands = Array.from(new Set([
    ...(data.wheelBrands || []),
    ...(data.tyreBrands || []),
    ...publishedCatalogGroups.map((group) => group.brand).filter(Boolean)
  ])).sort((a, b) => a.localeCompare(b));
  const normaliseSearch = (value) => String(value).toLowerCase().replace(/[^a-z0-9]/g, "");
  const productSlug = (...parts) => parts
    .filter(Boolean)
    .join("-")
    .toLowerCase()
    .replace(/\+/g, "-plus")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  const levenshteinDistance = (left, right, maxDistance = Number.POSITIVE_INFINITY) => {
    if (left === right) {
      return 0;
    }

    if (!left.length || !right.length) {
      return Math.max(left.length, right.length);
    }

    if (Math.abs(left.length - right.length) > maxDistance) {
      return maxDistance + 1;
    }

    let previous = Array.from({ length: right.length + 1 }, (_, index) => index);

    for (let leftIndex = 1; leftIndex <= left.length; leftIndex += 1) {
      const current = [leftIndex];
      let bestInRow = current[0];

      for (let rightIndex = 1; rightIndex <= right.length; rightIndex += 1) {
        const substitutionCost = left[leftIndex - 1] === right[rightIndex - 1] ? 0 : 1;
        const value = Math.min(
          previous[rightIndex] + 1,
          current[rightIndex - 1] + 1,
          previous[rightIndex - 1] + substitutionCost
        );

        current[rightIndex] = value;
        bestInRow = Math.min(bestInRow, value);
      }

      if (bestInRow > maxDistance) {
        return maxDistance + 1;
      }

      previous = current;
    }

    return previous[right.length];
  };

  const brandAliases = new Map([
    ["BF Goodrich", ["bfg", "bfgoodrich", "goodrich"]],
    ["GT Radial", ["gtradial", "gt"]],
    ["JSR Wheels", ["jsr", "jsrwheels", "japanstreetracing"]],
    ["KMC Wheels", ["kmc", "kmcwheels"]],
    ["CSA Wheels", ["csa", "csawheels"]],
    ["Icon Alloys", ["icon", "iconalloys"]],
    ["Dynamic Steel Wheels", ["dynamic", "dynamicsteel", "dynamicsteelwheels"]],
    ["DWC Wheels", ["dwc", "dynamicalloy", "dwcwheels"]],
    ["Level 8 Motorsports", ["level8", "level8motorsports"]],
    ["Mickey Thompson", ["mickey", "thompson", "mickeythompson"]],
    ["PDXX", ["pdx", "pdxx"]],
    ["R Series", ["rseries"]],
    ["Street Pro", ["streetpro", "street", "pro"]],
    ["US Mags", ["usmags", "usmag"]],
    ["XD Wheels", ["xd", "xdwheels"]]
  ]);

  const brandMatchScore = (brand, query) => {
    const normalisedQuery = normaliseSearch(query);

    if (!normalisedQuery) {
      return 100;
    }

    const normalisedBrand = normaliseSearch(brand);
    const aliases = brandAliases.get(brand) || [];
    const brandTokens = String(brand).split(/[^a-zA-Z0-9]+/).map(normaliseSearch).filter((token) => token.length >= 2);
    const candidates = [
      normalisedBrand,
      ...aliases.map(normaliseSearch),
      ...brandTokens
    ];

    if (candidates.some((candidate) => candidate === normalisedQuery)) {
      return 100;
    }

    if (candidates.some((candidate) => candidate.includes(normalisedQuery) || normalisedQuery.includes(candidate))) {
      return 88 - Math.min(normalisedQuery.length, 18);
    }

    const fuzzyCandidates = [
      normalisedBrand,
      ...aliases.map(normaliseSearch),
      ...brandTokens.filter((token) => token.length >= 4 && normalisedQuery.length >= 4 && Math.abs(token.length - normalisedQuery.length) <= 2)
    ].filter((candidate, index, list) => candidate && list.indexOf(candidate) === index);
    const scores = fuzzyCandidates.map((candidate) => {
      const allowedDistance = Math.max(1, Math.ceil(Math.min(candidate.length, normalisedQuery.length) * 0.32));
      const lengthPenalty = Math.abs(candidate.length - normalisedQuery.length);
      const distance = levenshteinDistance(candidate, normalisedQuery, allowedDistance);

      return distance <= allowedDistance ? 70 - distance - lengthPenalty : -1;
    });
    const bestScore = Math.max(...scores, -1);

    return bestScore >= 58 ? bestScore : -1;
  };

  const productSearchMatches = (product, query, normalisedQuery) => {
    if (!query) {
      return true;
    }

    if (product.searchText.includes(query) || product.normalisedSearchText.includes(normalisedQuery)) {
      return true;
    }

    const terms = [product.brand, product.model, product.category]
      .flatMap((value) => String(value).split(/[^a-zA-Z0-9]+/))
      .map(normaliseSearch)
      .filter((term) => term.length >= 4);

    return terms.some((term) => {
      if (Math.abs(term.length - normalisedQuery.length) > 2) {
        return false;
      }

      const allowedDistance = Math.max(1, Math.ceil(Math.min(term.length, normalisedQuery.length) * 0.28));
      return levenshteinDistance(term, normalisedQuery, allowedDistance) <= allowedDistance;
    });
  };

  const normaliseBoltPatterns = (value = "") => Array.from(
    String(value).toLowerCase().matchAll(/(\d+)\s*[x×]\s*(\d+(?:\.\d+)?)/g),
    (match) => `${Number(match[1])}x${Number(match[2])}`
  ).filter((pattern, index, patterns) => patterns.indexOf(pattern) === index);
  const normaliseBoltPattern = (value = "") => normaliseBoltPatterns(value)[0] || "";
  const boltPatternParts = (value = "") => {
    const match = normaliseBoltPattern(value).match(/^(\d+)x(\d+(?:\.\d+)?)$/);
    return match ? { lugs: Number(match[1]), diameter: Number(match[2]) } : null;
  };
  const boltPatternsMatch = (left, right) => {
    const leftParts = boltPatternParts(left);
    const rightParts = boltPatternParts(right);

    return Boolean(
      leftParts
      && rightParts
      && leftParts.lugs === rightParts.lugs
      && Math.abs(leftParts.diameter - rightParts.diameter) <= 0.1
    );
  };
  const boltPatternListIncludes = (patterns, target) => patterns.some((pattern) => boltPatternsMatch(pattern, target));

  const wheelRangeBoltPatterns = (range) => Array.from(new Set(
    (Array.isArray(range?.pcds) ? range.pcds : [range?.pcds])
      .flatMap((value) => normaliseBoltPatterns(value || ""))
  ));

  const wheelRangeDiameters = (range) => Array.from(new Set([
    ...(Array.isArray(range?.diameters) ? range.diameters : []),
    ...(Array.isArray(range?.sizes) ? range.sizes.map((size) => parseWheelSizeText(size)?.diameter) : [])
  ].map(Number).filter(Number.isFinite)));

  const wheelCoverageIsPcdComplete = (coverage) => (
    coverage?.status === "complete"
    && coverage.publishedRangeComplete !== false
    && coverage.completeRange !== false
    && coverage.pcdCoverageComplete !== false
  );

  const parseFitmentNumber = (value) => {
    const match = String(value ?? "").match(/-?\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : null;
  };

  const parseWheelSizeText = (value) => {
    const match = String(value || "").match(/(\d{1,2}(?:\.\d+)?)\s*J?\s*x\s*(\d{1,2}(?:\.\d+)?)/i);

    if (!match) {
      return null;
    }

    const first = Number(match[1]);
    const second = Number(match[2]);

    return first >= 13
      ? { diameter: first, width: second }
      : { diameter: second, width: first };
  };

  const vehicleFitmentProfile = () => {
    const record = fitmentReadStored();
    const fitment = record?.fitment || {};
    const wheelSizeTexts = Array.isArray(fitment.wheelSizes) ? fitment.wheelSizes : String(fitment.wheelSizes || "").split(",");
    const offsetTexts = Array.isArray(fitment.offsets) ? fitment.offsets : String(fitment.offsets || "").split(",");
    const wheelSizes = wheelSizeTexts
      .map(parseWheelSizeText)
      .filter(Boolean)
    const offsets = offsetTexts
      .map(parseFitmentNumber)
      .filter((value) => Number.isFinite(value));

    return {
      record,
      boltPattern: normaliseBoltPattern(fitment.boltPattern),
      boltPatterns: normaliseBoltPatterns(fitment.boltPattern),
      centreBore: parseFitmentNumber(fitment.centreBore || fitment.centerBore),
      wheelSizes,
      offsets
    };
  };

  const rowHasCompatibleBore = (row, vehicleCentreBore) => {
    if (!Number.isFinite(vehicleCentreBore) || !Number.isFinite(row.centre_bore_mm)) {
      return false;
    }

    return row.centre_bore_mm + 0.2 >= vehicleCentreBore;
  };

  const rowHasLikelySize = (row, profile) => {
    if (!profile.wheelSizes.length || !profile.offsets.length) {
      return false;
    }

    const diameters = profile.wheelSizes.map((size) => size.diameter);
    const widths = profile.wheelSizes.map((size) => size.width);
    const minDiameter = Math.min(...diameters);
    const maxDiameter = Math.max(...diameters);
    const maxWidth = Math.max(...widths);
    const matchesSize = row.diameter_in >= minDiameter && row.diameter_in <= maxDiameter + 2 && row.width_in <= maxWidth + 2;
    const matchesOffset = profile.offsets.some((offset) => Number.isFinite(row.offset_mm) && Math.abs(row.offset_mm - offset) <= 10);

    return matchesSize && matchesOffset;
  };

  const wheelFitmentStatusForRow = (row, profile) => {
    if (!profile?.record) {
      return null;
    }

    if (!profile.boltPatterns.length) {
      return {
        status: "check",
        label: "Check fitment",
        symbol: "-",
        detail: "The selected vehicle is missing bolt pattern data."
      };
    }

    const rowBoltPatterns = normaliseBoltPatterns(row.pcd);

    if (!rowBoltPatterns.length) {
      return {
        status: "check",
        label: "Check fitment",
        symbol: "-",
        detail: "This rim variant is missing verified PCD data."
      };
    }

    const matchesPcd = rowBoltPatterns.some((pattern) => boltPatternListIncludes(profile.boltPatterns, pattern));

    if (!matchesPcd) {
      return {
        status: "wont",
        label: "Won't fit",
        symbol: "X",
        detail: "This rim variant's PCD does not match the selected vehicle."
      };
    }

    if (!Number.isFinite(profile.centreBore)) {
      return {
        status: "check",
        label: "Check fitment",
        symbol: "-",
        detail: "The selected vehicle is missing centre bore data."
      };
    }

    if (!Number.isFinite(row.centre_bore_mm)) {
      return {
        status: "check",
        label: "Check fitment",
        symbol: "-",
        detail: "This rim variant's centre bore has not been verified."
      };
    }

    if (!rowHasCompatibleBore(row, profile.centreBore)) {
      return {
        status: "wont",
        label: "Won't fit",
        symbol: "X",
        detail: "This rim variant's centre bore is smaller than the selected vehicle requires."
      };
    }

    if (rowHasLikelySize(row, profile)) {
      return {
        status: "likely",
        label: "Likely fits",
        symbol: "&#10003;",
        detail: "This exact rim variant closely matches the selected vehicle's PCD, centre bore, wheel size and offset. Final clearance still needs confirmation."
      };
    }

    return {
      status: "check",
      label: "Check fitment",
      symbol: "-",
      detail: "The PCD and centre bore match, but this rim variant's size, offset or final clearance still needs confirmation."
    };
  };

  const productFitmentStatusFor = (product, profileOverride = null) => {
    if (product.category === "Accessories") {
      return null;
    }

    if (product.category !== "Wheels") {
      return {
        status: "none",
        label: "No data",
        symbol: "?",
        detail: `Vehicle compatibility matching is not available for ${String(product.category || "this product type").toLowerCase()}.`
      };
    }

    const profile = profileOverride || vehicleFitmentProfile();

    if (!profile.record) {
      return {
        status: "none",
        label: "Add vehicle",
        symbol: "?",
        detail: "Add your vehicle to check this wheel against its published fitment data."
      };
    }

    const rows = product.wheelSpecs || [];
    const rangeBoltPatterns = wheelRangeBoltPatterns(product.wheelSpecRange);
    const rangeMatchesPcd = rangeBoltPatterns.some((pattern) => boltPatternListIncludes(profile.boltPatterns, pattern));

    if (!profile.boltPatterns.length) {
      return {
        status: "check",
        label: "Check fitment",
        symbol: "-",
        detail: "Selected vehicle is missing bolt pattern data."
      };
    }

    if (!rows.length && rangeMatchesPcd) {
      return {
        status: "check",
        label: "Check fitment",
        symbol: "-",
        detail: "The manufacturer publishes the selected bolt pattern for this rim, but the exact size, offset and centre-bore combination still needs confirmation."
      };
    }

    if (!rows.length && rangeBoltPatterns.length && wheelCoverageIsPcdComplete(product.wheelSpecCoverage)) {
      return {
        status: "wont",
        label: "Won't fit",
        symbol: "X",
        detail: "The complete published manufacturer range has no bolt pattern matching the selected vehicle."
      };
    }

    if (!rows.length) {
      return {
        status: "check",
        label: "Check fitment",
        symbol: "-",
        detail: "Verified rim specs are not loaded for this model yet."
      };
    }

    const pcdRows = rows.filter((row) => normaliseBoltPatterns(row.pcd).some((pattern) => boltPatternListIncludes(profile.boltPatterns, pattern)));

    if (!pcdRows.length) {
      if (rangeMatchesPcd) {
        return {
          status: "check",
          label: "Check fitment",
          symbol: "-",
          detail: "The broader published range includes the selected bolt pattern, but an exact verified variant combination is not loaded yet."
        };
      }

      if (wheelCoverageIsPcdComplete(product.wheelSpecCoverage)) {
        return {
          status: "wont",
          label: "Won't fit",
          symbol: "X",
          detail: "The complete published manufacturer range has no bolt pattern matching the selected vehicle."
        };
      }

      return {
        status: "check",
        label: "Check fitment",
        symbol: "-",
        detail: "No matching bolt pattern is present in the verified variants loaded so far. 110 Garage should check the full supplier range."
      };
    }

    if (!Number.isFinite(profile.centreBore)) {
      return {
        status: "check",
        label: "Check fitment",
        symbol: "-",
        detail: "The selected vehicle is missing centre bore data, so fitment needs manual confirmation."
      };
    }

    const rowsWithKnownBore = pcdRows.filter((row) => Number.isFinite(row.centre_bore_mm));
    const rowsWithUnknownBore = pcdRows.filter((row) => !Number.isFinite(row.centre_bore_mm));

    if (!rowsWithKnownBore.length) {
      return {
        status: "check",
        label: "Check fitment",
        symbol: "-",
        detail: "A matching PCD exists, but centre bore is not verified for this rim."
      };
    }

    const boreRows = rowsWithKnownBore.filter((row) => rowHasCompatibleBore(row, profile.centreBore));

    if (!boreRows.length) {
      if (rowsWithUnknownBore.length) {
        return {
          status: "check",
          label: "Check fitment",
          symbol: "-",
          detail: "A matching PCD exists, but centre bore is not verified for every relevant rim variant."
        };
      }

      if (wheelCoverageIsPcdComplete(product.wheelSpecCoverage)) {
        return {
          status: "wont",
          label: "Won't fit",
          symbol: "X",
          detail: "Every published matching-PCD variant has a centre bore smaller than the selected vehicle requires."
        };
      }

      return {
        status: "check",
        label: "Check fitment",
        symbol: "-",
        detail: "The loaded matching-PCD variants have smaller centre bores, but the complete manufacturer range is not verified yet."
      };
    }

    const likelyRows = boreRows.filter((row) => rowHasLikelySize(row, profile));

    if (likelyRows.length) {
      return {
        status: "likely",
        label: "Likely fits",
        symbol: "&#10003;",
        detail: `${likelyRows.length} verified rim variant${likelyRows.length === 1 ? " closely matches" : "s closely match"} the selected vehicle specs. 110 Garage should still confirm clearance.`
      };
    }

    return {
      status: "check",
      label: "Check fitment",
      symbol: "-",
      detail: "A matching PCD and bore exists, but size or offset needs manual confirmation."
    };
  };

  const productFitmentBadgeMarkupFor = (product, className = "wheel-fitment-badge") => {
    const badge = productFitmentStatusFor(product);

    if (!badge) {
      return "";
    }

    return `<span class="${className} wheel-fitment-badge wheel-fitment-badge--${escapeHtml(badge.status)}" data-fitment-status="${escapeHtml(badge.status)}" title="${escapeHtml(badge.detail)}"><span aria-hidden="true">${badge.symbol}</span>${escapeHtml(badge.label)}</span>`;
  };

  const fourByFourWheelBrands = new Set([
    "PDXX",
    "Dirty Life",
    "R Series",
    "KMC Wheels",
    "Mayhem",
    "Level 8 Motorsports",
    "Icon Alloys",
    "Raceline Wheels",
    "Rubicon",
    "Mickey Thompson",
    "Moto Metal",
    "Pro Comp",
    "Dynamic Wheel Co",
    "Dynamic Steel Wheels",
    "DWC Wheels",
    "Ion Wheels",
    "XD Wheels"
  ]);
  const passengerWheelBrands = new Set([
    "Advanti Racing",
    "American Racing",
    "Asanti Wheels",
    "Enkei",
    "GT Form",
    "JSR Wheels",
    "Lenso",
    "Motegi",
    "Orbit",
    "Petrol",
    "Reproduction Wheels",
    "Rotiform",
    "Street Pro",
    "TSW",
    "US Mags",
    "Kensei",
    "Konig",
    "Globe"
  ]);
  const fourByFourWheelPattern = /4x4|4wd|offroad|off-road|beadlock|bead lock|mud|trail|crawler|krawler|rubicon|patrol|landcruiser|land cruiser|ranger|raptor|hilux|gladiator|wrangler|bronco|baja|assault|havoc|dakar|raid|blak trak|hammer|outlaw|renegade|ridgeline|maverick|monster|predator|commando|militant|jackal|tracker|outback|desert|sunraysia|steel|dynamic|rebound|recon|raider|journey|compression|cajon|anza|alpha|bandit|warrior|scout|tank|grenade|rockstar|hoss|panzer|pike|reactor|thump|bomber|colossus|onslaught|rover|gauntlet|beacon|basecamp|roughneck|stryker|grid|snare|patriot|bandido/i;
  const passengerWheelPattern = /street|racing|race|sport|touring|drift|classic|muscle|forged|convo|monaco|bathurst|sprint|rally|dragway|daytona|eliminator|interceptor|challenger|cruiser|rpf|advan|storm|hypergram|dekagram|countergram|ultraform|reasons|torch|wideopen|rotiform|tsw|mags|magnum|verona|denaro|vigoroso|hybris|alonso|predator 5/i;
  const wheelUseFor = (product) => {
    if (product.category !== "Wheels") {
      return "";
    }

    const searchable = `${product.brand} ${product.model}`;
    const modelSearch = product.model;

    if (/^et drag$/i.test(modelSearch) || /drag/i.test(modelSearch)) {
      return "Passenger";
    }

    if (fourByFourWheelPattern.test(modelSearch)) {
      return "4x4";
    }

    if (fourByFourWheelBrands.has(product.brand)) {
      return "4x4";
    }

    if (passengerWheelPattern.test(searchable)) {
      return "Passenger";
    }

    if (passengerWheelBrands.has(product.brand)) {
      return "Passenger";
    }

    return "Passenger";
  };
  const fourByFourTyrePattern = /4x4|4wd|a\/t|at2|at3|at4|all.?terrain|m\/t|mud|mud.?terrain|rugged|trail|open country|geolandar|wildpeak|dueler|scorpion|road venture|grabber|renegade|baja|dynapro|roadian|adventuro|s\/t|x-?at|r\/t|h\/t|suv|ltx|light.?truck|courser|klever|savero|discoverer|stronghold|stt|razr|bighorn|mudzilla|bravo (?:at|ht)|ma-?(?:751|589)|agilex/i;
  const passengerTyrePattern = /passenger|pilot|primacy|potenza|turanza|ecopia|p zero|cinturato|powergy|dragon|sportcontact|premiumcontact|ecocontact|comfortcontact|maxcontact|advan|bluearth|proxes|nanoenergy|ventus|kinergy|optimo|ecsta|solus|sense|sportactive|champiro|dimax|rivera|rpx|n'?fera|n'?blue|n'?priz|advantage|g-force|radial|stratus|avenger|evolution|zeon|premitra|victra|mecotra|komet|kenetica|vezda/i;
  const tyreUseFor = (product) => {
    if (product.category !== "Tyres") {
      return "";
    }

    const searchable = `${product.brand} ${product.model}`;

    if (fourByFourTyrePattern.test(searchable)) {
      return "4x4";
    }

    if (passengerTyrePattern.test(searchable)) {
      return "Passenger";
    }

    return "Passenger";
  };

  const pageSize = 20;
  const detailKeyFor = (category, brand, model) => `${category}::${brand}::${model}`;
  const assetScript = document.querySelector('script[src*="theme.js"]');
  const assetBaseUrl = assetScript ? assetScript.src.split("/theme.js")[0] : "";
  const localAssetUrlFor = (filename) => {
    return filename && assetBaseUrl ? `${assetBaseUrl}/${filename}` : "";
  };
  const logoSource = catalogShop.querySelector(".shop-brand-logo-source");
  const brandLogoMap = new Map();

  logoSource?.querySelectorAll(".supplier-logo-marquee__item img").forEach((image) => {
    const brand = image.getAttribute("alt")?.replace(/\s+brand logo$/i, "").trim() || "";
    const src = image.currentSrc || image.getAttribute("src") || "";
    const tone = image.closest(".supplier-logo-marquee__item--light") ? "light" : "dark";

    if (!brand || !src) {
      return;
    }

    brandLogoMap.set(brand, { src, tone });
    brandLogoMap.set(normaliseSearch(brand), { src, tone });
  });

  const logoForBrand = (brand) => brandLogoMap.get(brand) || brandLogoMap.get(normaliseSearch(brand));
  const seededProducts = publishedCatalogGroups.flatMap((group) => {
    return (group.models || []).map((model) => ({
      brand: group.brand,
      category: group.category,
      model,
      detailKey: detailKeyFor(group.category, group.brand, model),
      id: productSlug(group.category, group.brand, model),
      localImage: group.localImages?.[model] || "",
      image: group.images?.[model] || "",
      description: group.descriptions?.[model] || "",
      availableSizes: group.availableSizes?.[model] || [],
      productUrl: group.productUrls?.[model] || group.sourceUrl || "",
      sourceUrl: group.sourceUrl || "",
      searchText: `${group.category} ${group.brand} ${model}`.toLowerCase(),
      normalisedSearchText: normaliseSearch(`${group.category} ${group.brand} ${model}`)
    }));
  });
  const seededBrandCategories = new Set(seededProducts.map((product) => `${product.category}:${product.brand}`));
  const brandRangeProducts = [
    ...(data.tyreBrands || []).map((brand) => ({ brand, category: "Tyres" })),
    ...(data.wheelBrands || []).map((brand) => ({ brand, category: "Wheels" }))
  ].filter((item) => !seededBrandCategories.has(`${item.category}:${item.brand}`)).map((item) => ({
    brand: item.brand,
    category: item.category,
    model: `${item.brand} range`,
    id: productSlug(item.category, item.brand, "range"),
    image: "",
    description: "",
    availableSizes: [],
    productUrl: "",
    sourceUrl: "",
    isBrandRange: true,
    searchText: `${item.category} ${item.brand} ${item.brand} range available shop enquiry`.toLowerCase(),
    normalisedSearchText: normaliseSearch(`${item.category} ${item.brand} ${item.brand} range available shop enquiry`)
  }));
  const products = [...seededProducts, ...brandRangeProducts];
  products.forEach((product) => {
    const productDetails = details[product.detailKey] || {};
    product.image = productDetails.images?.[0] || productDetails.image || product.image;
    product.localImage = productDetails.localImage || product.localImage;
    product.images = productDetails.images || (product.image ? [product.image] : []);
    product.description = productDetails.description || product.description;
    product.availableSizes = productDetails.availableSizes || product.availableSizes;
    product.notes = productDetails.notes || [];
    product.features = productDetails.features || [];
    product.specifications = productDetails.specifications || {};
    product.galleryImages = productDetails.galleryImages || [];
    product.productUrl = productDetails.productUrl || product.productUrl;
    product.imageSourceUrl = productDetails.imageSourceUrl || "";
    product.imageStatus = productDetails.imageStatus || "";
    product.wheelSpecs = wheelSpecRowsByKey[product.detailKey] || [];
    product.wheelSpecCoverage = wheelSpecCoverageByKey[product.detailKey] || null;
    product.wheelSpecRange = wheelSpecRangesByKey[product.detailKey] || null;
    product.wheelUse = wheelUseFor(product);
    product.tyreUse = tyreUseFor(product);

    if (product.wheelUse) {
      const wheelUseTerms = product.wheelUse === "4x4"
        ? "4x4 4wd offroad off-road all terrain wheel wheels"
        : "passenger street performance car wheel wheels";
      product.searchText = `${product.searchText} ${wheelUseTerms}`.toLowerCase();
      product.normalisedSearchText = normaliseSearch(product.searchText);
    }

    if (product.tyreUse) {
      const tyreUseTerms = product.tyreUse === "4x4"
        ? "4x4 4wd offroad off-road all terrain tyre tire tyres tires"
        : "passenger street performance car tyre tire tyres tires";
      product.searchText = `${product.searchText} ${tyreUseTerms}`.toLowerCase();
      product.normalisedSearchText = normaliseSearch(product.searchText);
    }
  });
  const selectedCategories = new Set();
  const selectedSubcategories = {
    Tyres: new Set(),
    Wheels: new Set()
  };
  const selectedWheelDiameters = new Set();
  let currentPage = 1;

  const escapeHtml = (value) => {
    return String(value).replace(/[&<>"']/g, (character) => {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "\"": "&quot;",
        "'": "&#39;"
      }[character];
    });
  };

  const decodeHtml = (value) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = String(value || "");
    return textarea.value;
  };

  const cleanProductText = (value) => {
    const decoded = decodeHtml(value)
      .replace(/\[et_pb[\s\S]*$/i, "")
      .replace(/\[\/?et_[^\]]+\]/gi, " ")
      .replace(/\b(?:_builder_version|sale_badge|custom_padding|background_(?:size|position|repeat)|admin_label)=\S+/gi, " ")
      .replace(/\s+/g, " ")
      .trim();

    if (!decoded || decoded.length < 32 || decoded.match(/et_pb|_builder_version|sale_badge_text_color/i)) {
      return "";
    }

    if (decoded.match(/Select your store|Passenger Tires Passenger|TRUCK\/SUV\/CUV|Commercial Truck Tires|Off-the-Road Tires|Tire Line-up|Tyre Line-up|Vehicle Gallery|Home Posts Gallery|Gallery Understanding Fitment|HOME Wheels Dealers Visualizer|Previous Page STYLE|Size Code|P\.R\.|LI\/SR|T\.D\.|O\.D\.|S\.W\.|R\.W\.|LCC@AP|32nds|\b\d{3}\/\d{2}R\d{2}\b|Triangle Tire is proud to have developed|available through 110 Garage|listed in the .* (?:catalog(?:ue)?|shop)|Contact the shop for current Australian availability/i)) {
      return "";
    }

    if (decoded.length <= 640) {
      return decoded;
    }

    const clipped = decoded.slice(0, 640);
    const sentenceEnd = Math.max(clipped.lastIndexOf(". "), clipped.lastIndexOf("! "), clipped.lastIndexOf("? "));
    return (sentenceEnd > 160 ? clipped.slice(0, sentenceEnd + 1) : clipped).trim();
  };

  const enquiryUrlFor = (product) => {
    const params = new URLSearchParams({
      product: `${product.brand} ${product.model}`,
      brand: product.brand,
      category: product.category
    });
    const referenceImage = product.localImage
      ? localAssetUrlFor(product.localImage)
      : (product.images?.[0] || product.image || "");
    const referenceSource = product.productUrl || product.sourceUrl || "";

    if (referenceImage) {
      params.set("image", referenceImage);
    }

    if (referenceSource) {
      params.set("source", referenceSource);
    }

    return `/pages/contact?${params.toString()}`;
  };

  const inlineContactLinkFor = (product, label = "Contact us") => {
    return `<a class="inline-fill-link" href="${escapeHtml(enquiryUrlFor(product))}">${escapeHtml(label)}</a>`;
  };

  const isDefaultDescription = (value) => {
    return String(value || "").match(/^contact us for more information regarding this product!?$/i);
  };

  const defaultDescriptionMarkupFor = (product) => {
    return `${inlineContactLinkFor(product, "Contact us")} for more information regarding this product!`;
  };

  const stripPricingLanguage = (value) => {
    const sourceText = String(value || "");

    if (!/\b(?:msrp|pricing|prices?|priced|cost(?:s)?|money)\b/i.test(sourceText)) {
      return sourceText;
    }

    const withoutPricingNotices = sourceText
      .replace(/\*{0,2}\s*staggered options price variance\s*\*{0,2}/gi, " ")
      .replace(/\*{0,2}\s*price is per wheel\s*&\s*valve stems are not included\.?\s*\*{0,2}/gi, " ")
      .replace(/\bBridgestone Pricing Available Online\b/gi, " ")
      .replace(/\bTyre Price Promise\b/gi, " ")
      .replace(/\bpricing and stock\b/gi, "stock")
      .replace(/\bthat are cost-effective for all applications\b/gi, "for all applications")
      .replace(/\bunbeatable value for money\b/gi, "a strong all-round choice")
      .replace(/\bwho want to save money\b/gi, "who value everyday efficiency")
      .replace(/\bgreater cost savings\b/gi, "greater efficiency")
      .replace(/\bperformance and cost saving fuel efficiency\b/gi, "performance and fuel efficiency")
      .replace(/\bcast-level cost efficiency\b/gi, "efficient flow-formed construction")
      .replace(/\bat cast wheel prices\b/gi, "")
      .replace(/\bAt an accessible FFT price point,\s*this wheel\b/gi, "This wheel")
      .replace(/\bPriced per wheel,\s*/gi, "");
    const sentences = withoutPricingNotices.split(/(?<=[.!?])\s+/);

    return sentences
      .filter((sentence) => !/\b(?:msrp|pricing|prices?|priced|cost(?:s)?|money)\b/i.test(sentence))
      .join(" ")
      .replace(/\s+([,.!?;:])/g, "$1")
      .replace(/\s+/g, " ")
      .trim();
  };

  const descriptionMarkupFor = (product) => {
    const cleanDescription = stripPricingLanguage(cleanProductText(product.description));

    if (cleanDescription && !isDefaultDescription(cleanDescription)) {
      return escapeHtml(cleanDescription);
    }

    return "";
  };

  const fitmentMarkupFor = (product) => {
    const badge = productFitmentStatusFor(product);

    if (product.category === "Accessories") {
      return `<li>${inlineContactLinkFor(product, "Contact us")} to confirm compatibility, finish and current availability.</li>`;
    }

    if (product.category === "Wheels" && badge) {
      const rows = product.wheelSpecs || [];
      const profile = vehicleFitmentProfile();
      const matchingRows = rows
        .filter((row) => boltPatternListIncludes(normaliseBoltPatterns(row.pcd), profile.boltPattern))
        .filter((row) => rowHasCompatibleBore(row, profile.centreBore))
        .slice(0, 5);

      if (matchingRows.length) {
        return matchingRows.map((row) => {
          const size = `${row.diameter_in}x${row.width_in}`;
          const offset = Number.isFinite(row.offset_mm) ? ` ET${row.offset_mm}` : "";
          const bore = Number.isFinite(row.centre_bore_mm) ? ` CB${row.centre_bore_mm}` : "";
          const finish = row.finish ? ` ${row.finish}` : "";

          return `<li>${escapeHtml(size)} ${escapeHtml(row.pcd)}${escapeHtml(offset)}${escapeHtml(bore)}${escapeHtml(finish)}</li>`;
        }).join("");
      }

      return `<li>${escapeHtml(badge.detail)} ${inlineContactLinkFor(product, "Contact us")} to confirm.</li>`;
    }

    return `<li>Get in ${inlineContactLinkFor(product, "contact")} with us to learn if this fits your vehicle!</li>`;
  };

  const placeholderImageFor = (product) => {
    if (product.category === "Accessories") {
      return localAssetUrlFor("catalog-placeholder-accessory.svg");
    }

    return localAssetUrlFor(product.category === "Tyres" ? "catalog-placeholder-tyre.png" : "catalog-placeholder-wheel.png");
  };

  const badImageProductKeys = new Set([
    "Tyres::Mickey Thompson::Baja Pro X Competition",
    "Tyres::Mickey Thompson::Deegan 38 Mud-Terrain",
    "Tyres::Maxxis::MA-P5",
    "Tyres::Toyo::Open Country M/T",
    "Tyres::Toyo::NanoEnergy Van",
    "Wheels::Raceline Wheels::Clutch"
  ]);

  const badImageSourcePattern = /truck-builds|quick-edit|cap-screw|1_Bolt|bolt[_-]?on[_-]?cap|\/caps?\b|store\.jpg|car-tyres\.jpg|blog_new|articles\/content/i;

  const hasBadCatalogImage = (product) => {
    if (String(product.imageStatus || "").startsWith("blocked")) {
      return true;
    }

    const sourceText = [
      product.detailKey,
      product.localImage,
      product.image,
      product.imageSourceUrl,
      product.productUrl,
      product.description
    ].join(" ");

    return badImageProductKeys.has(product.detailKey) || badImageSourcePattern.test(sourceText);
  };

  const imageFor = (product) => {
    if (hasBadCatalogImage(product)) {
      return "";
    }

    return localAssetUrlFor(product.localImage) || product.image || "";
  };

  const productDetailUrlFor = (product) => {
    const url = new URL(window.location.href);
    url.searchParams.set("product", product.id);
    return `${url.pathname}${url.search}`;
  };

  const productImagesFor = (product) => {
    if (hasBadCatalogImage(product)) {
      return [];
    }

    const localImage = localAssetUrlFor(product.localImage);
    const detailImages = [
      ...(Array.isArray(product.galleryImages) ? product.galleryImages : []),
      ...(Array.isArray(product.images) ? product.images : []),
      product.image
    ].filter(Boolean).map((image) => {
      const value = String(image);
      return value.match(/^(?:https?:)?\/\//i) || value.startsWith("/") ? value : localAssetUrlFor(value);
    });
    const candidates = [localImage, ...detailImages].filter(Boolean);

    return candidates.filter((image, index, list) => {
      const cleanImage = String(image).split("?")[0].toLowerCase();
      return list.findIndex((candidate) => String(candidate).split("?")[0].toLowerCase() === cleanImage) === index;
    });
  };

  const categoryClassFor = (product) => {
    return normaliseSearch(product.category || "wheels") || "wheels";
  };

  const hasActiveProductFilters = () => selectedCategories.size > 0;

  const hasActiveWheelSpecFilters = () => selectedWheelDiameters.size > 0 || Boolean(boltPatternSelect?.value && boltPatternSelect.value !== "All");

  const hasAnyCatalogFilters = () => (
    hasActiveProductFilters()
    || hasActiveWheelSpecFilters()
    || Boolean(brandSelect?.value && brandSelect.value !== "All")
    || Boolean(searchInput?.value.trim())
  );

  const resetProductFilters = () => {
    selectedCategories.clear();
    selectedSubcategories.Tyres.clear();
    selectedSubcategories.Wheels.clear();
    selectedWheelDiameters.clear();

    if (boltPatternSelect) {
      boltPatternSelect.value = "All";
    }
  };

  const addProductFilter = (category, subcategory = "") => {
    if (!category || category === "All") {
      resetProductFilters();
      return;
    }

    selectedCategories.add(category);

    if ((category === "Tyres" || category === "Wheels") && subcategory) {
      selectedSubcategories[category].add(subcategory);
    }
  };

  const toggleProductFilter = (category) => {
    if (!category || category === "All") {
      resetProductFilters();
      return;
    }

    if (selectedCategories.has(category)) {
      selectedCategories.delete(category);

      if (selectedSubcategories[category]) {
        selectedSubcategories[category].clear();
      }
    } else {
      selectedCategories.add(category);
    }
  };

  const toggleProductSubcategory = (category, subcategory) => {
    if (!category || !subcategory || !selectedSubcategories[category]) {
      return;
    }

    selectedCategories.add(category);

    if (selectedSubcategories[category].has(subcategory)) {
      selectedSubcategories[category].delete(subcategory);
    } else {
      selectedSubcategories[category].add(subcategory);
    }
  };

  const productMatchesSelectedCategory = (product, category) => {
    if (category === "Wheels") {
      if (product.category !== "Wheels") {
        return false;
      }

      const subcategories = selectedSubcategories.Wheels;
      return !subcategories.size || subcategories.has(product.wheelUse);
    }

    if (category === "Tyres") {
      if (product.category !== "Tyres") {
        return false;
      }

      const subcategories = selectedSubcategories.Tyres;
      return !subcategories.size || subcategories.has(product.tyreUse);
    }

    return product.category === category;
  };

  const matchesCategoryFilter = (product) => {
    if (!hasActiveProductFilters()) {
      return true;
    }

    return Array.from(selectedCategories).some((category) => productMatchesSelectedCategory(product, category));
  };

  const matchesWheelSpecFilters = (product) => {
    if (!hasActiveWheelSpecFilters()) {
      return true;
    }

    if (product.category !== "Wheels") {
      return false;
    }

    const selectedBoltPattern = boltPatternSelect?.value || "All";
    const rangeDiameters = wheelRangeDiameters(product.wheelSpecRange);
    const rangeBoltPatterns = wheelRangeBoltPatterns(product.wheelSpecRange);
    const rangeMatches = (rangeDiameters.length || rangeBoltPatterns.length) &&
      (!selectedWheelDiameters.size || rangeDiameters.some((diameter) => selectedWheelDiameters.has(String(diameter)))) &&
      (selectedBoltPattern === "All" || boltPatternListIncludes(rangeBoltPatterns, selectedBoltPattern));

    const exactVariantMatches = product.wheelSpecs.some((row) => {
      const diameter = Number(row.diameter_in);
      const matchesDiameter = !selectedWheelDiameters.size || selectedWheelDiameters.has(String(diameter));
      const matchesBoltPattern = selectedBoltPattern === "All" || boltPatternListIncludes(normaliseBoltPatterns(row.pcd), selectedBoltPattern);
      return matchesDiameter && matchesBoltPattern;
    });

    return exactVariantMatches || rangeMatches;
  };

  const selectedLabelFor = (category) => {
    if (category === "Wheels" || category === "Tyres") {
      const subcategories = Array.from(selectedSubcategories[category] || []);

      if (subcategories.length === 1) {
        return `${subcategories[0]} ${category}`;
      }

      return category;
    }

    return category;
  };

  const activeFilterLabels = () => {
    const categories = Array.from(selectedCategories);
    const hasOnlyWheelsAndTyres = categories.length === 2 && categories.includes("Wheels") && categories.includes("Tyres");
    let labels = categories.map(selectedLabelFor);

    if (hasOnlyWheelsAndTyres) {
      const wheelSubs = selectedSubcategories.Wheels;
      const tyreSubs = selectedSubcategories.Tyres;

      if (wheelSubs.size === 1 && tyreSubs.size === 1) {
        const wheelSub = Array.from(wheelSubs)[0];
        const tyreSub = Array.from(tyreSubs)[0];

        if (wheelSub === tyreSub) {
          labels = [`${wheelSub} Products`];
        }
      }
    }

    if (selectedWheelDiameters.size) {
      labels.push(`${Array.from(selectedWheelDiameters).sort((a, b) => Number(a) - Number(b)).map((value) => `${value}\"`).join(", ")} wheels`);
    }

    if (boltPatternSelect?.value && boltPatternSelect.value !== "All") {
      labels.push(boltPatternSelect.value);
    }

    return labels;
  };

  const brandsForCategory = () => {
    return Array.from(new Set(
      products
        .filter((product) => matchesCategoryFilter(product))
        .map((product) => product.brand)
    )).sort((a, b) => a.localeCompare(b));
  };

  const allBrandLabelFor = () => {
    const labels = activeFilterLabels();

    if (labels.length === 1) {
      return `All ${labels[0].replace(/\s+Products$/i, "")} Brands`;
    }

    if (labels.length > 1) {
      return "All Matching Brands";
    }

    return "All Brands";
  };

  const populateBrandOptions = ({ preserveSelection = true } = {}) => {
    if (!brandSelect) {
      return "All";
    }

    const currentBrand = preserveSelection ? brandSelect.value : "All";
    const availableBrands = brandsForCategory();
    brandSelect.innerHTML = "";
    const allOption = document.createElement("option");
    allOption.value = "All";
    allOption.textContent = allBrandLabelFor();
    brandSelect.appendChild(allOption);

    availableBrands.forEach((brand) => {
      const option = document.createElement("option");
      option.value = brand;
      option.textContent = brand;
      brandSelect.appendChild(option);
    });

    brandSelect.value = availableBrands.includes(currentBrand) ? currentBrand : "All";
    return brandSelect.value;
  };

  const populateWheelSpecOptions = () => {
    const wheelRows = products.flatMap((product) => product.category === "Wheels" ? product.wheelSpecs : []);
    const wheelRanges = products.filter((product) => product.category === "Wheels").map((product) => product.wheelSpecRange).filter(Boolean);
    const diameters = Array.from(new Set(
      [
        ...wheelRows.map((row) => Number(row.diameter_in)),
        ...wheelRanges.flatMap(wheelRangeDiameters)
      ].filter((value) => Number.isFinite(value))
    )).sort((left, right) => left - right);
    const boltPatterns = Array.from(new Set([
      ...wheelRows.flatMap((row) => normaliseBoltPatterns(row.pcd)),
      ...wheelRanges.flatMap(wheelRangeBoltPatterns)
    ]))
      .filter((pattern) => !/^(?:8x100|10x)/.test(pattern))
      .sort((left, right) => {
        const [leftLugs, leftPcd] = left.split("x").map(Number);
        const [rightLugs, rightPcd] = right.split("x").map(Number);
        return leftLugs - rightLugs || leftPcd - rightPcd;
      })
      .filter((pattern, index, patterns) => !patterns.slice(0, index).some((existing) => boltPatternsMatch(existing, pattern)));

    if (wheelDiameterOptions) {
      wheelDiameterOptions.replaceChildren(...diameters.map((diameter) => {
        const label = document.createElement("label");
        label.className = "shop-diameter-option";
        const input = document.createElement("input");
        input.type = "checkbox";
        input.name = "catalog_wheel_diameter";
        input.value = String(diameter);
        input.dataset.catalogWheelDiameter = String(diameter);
        const text = document.createElement("span");
        text.textContent = `${diameter}\"`;
        label.append(input, text);
        return label;
      }));
    }

    if (boltPatternSelect) {
      boltPatternSelect.innerHTML = '<option value="All">All bolt patterns</option>';
      boltPatterns.forEach((pattern) => {
        const option = document.createElement("option");
        option.value = pattern;
        option.textContent = pattern;
        boltPatternSelect.append(option);
      });
    }
  };

  const updateFilterControls = () => {
    categoryButtons.forEach((button) => {
      const category = button.dataset.catalogCategory || "";
      const isActive = selectedCategories.has(category);
      button.checked = isActive;
      button.classList.toggle("is-active", isActive);
      button.closest(".shop-filter-option")?.classList.toggle("is-active", isActive);
    });

    subcategoryGroups.forEach((group) => {
      const isHidden = !selectedCategories.has(group.dataset.catalogSubcategoryGroup || "");
      group.hidden = isHidden;
      group.setAttribute("aria-hidden", isHidden ? "true" : "false");
    });

    subcategoryButtons.forEach((button) => {
      const parentCategory = button.dataset.catalogParentCategory || "";
      const subcategory = button.dataset.catalogSubcategory || "";
      const isActive = Boolean(selectedSubcategories[parentCategory]?.has(subcategory));
      button.checked = isActive;
      button.classList.toggle("is-active", isActive);
      button.closest(".shop-filter-option")?.classList.toggle("is-active", isActive);
    });

    wheelDiameterOptions?.querySelectorAll("[data-catalog-wheel-diameter]").forEach((input) => {
      const isActive = selectedWheelDiameters.has(input.value);
      input.checked = isActive;
      input.closest(".shop-diameter-option")?.classList.toggle("is-active", isActive);
    });

    if (wheelSpecFilterGroup) {
      const isWheelContext = !selectedCategories.size || selectedCategories.has("Wheels");
      wheelSpecFilterGroup.hidden = !isWheelContext;
    }

    if (filtersResetButton) {
      filtersResetButton.hidden = !hasAnyCatalogFilters();
    }
  };

  if (brandStrip) {
    brandStrip.innerHTML = allBrands.map((brand) => `<span>${escapeHtml(brand)}</span>`).join("");
  }

  populateWheelSpecOptions();

  const urlParams = new URLSearchParams(window.location.search);
  const bestBrandMatchFor = (value, candidateBrands = allBrands) => {
    const query = String(value || "").trim();

    if (!query) {
      return "";
    }

    const exactMatch = candidateBrands.find((brand) => normaliseSearch(brand) === normaliseSearch(query));

    if (exactMatch) {
      return exactMatch;
    }

    const bestMatch = candidateBrands
      .map((brand) => ({ brand, score: brandMatchScore(brand, query) }))
      .sort((left, right) => right.score - left.score)[0];

    return bestMatch?.score >= 58 ? bestMatch.brand : "";
  };

  const applyFilterPreset = (value) => {
    const normalisedValue = normaliseSearch(value);

    resetProductFilters();

    if (["4x4", "4wd", "4x4products", "4x4wheelsandtyres", "4x4wheelsandtires"].includes(normalisedValue)) {
      addProductFilter("Wheels", "4x4");
      addProductFilter("Tyres", "4x4");
      return true;
    }

    if (["passenger", "passengerproducts", "passengerwheelsandtyres", "passengerwheelsandtires"].includes(normalisedValue)) {
      addProductFilter("Wheels", "Passenger");
      addProductFilter("Tyres", "Passenger");
      return true;
    }

    if (["accessories", "accessory"].includes(normalisedValue)) {
      addProductFilter("Accessories");
      return true;
    }

    if (["accessoriesspecialties", "accessoriesandspecialties"].includes(normalisedValue)) {
      addProductFilter("Accessories");
      addProductFilter("Specialties");
      return true;
    }

    if (["4x4wheels"].includes(normalisedValue)) {
      addProductFilter("Wheels", "4x4");
      return true;
    }

    if (["passengerwheels"].includes(normalisedValue)) {
      addProductFilter("Wheels", "Passenger");
      return true;
    }

    if (["4x4tyres", "4x4tires"].includes(normalisedValue)) {
      addProductFilter("Tyres", "4x4");
      return true;
    }

    if (["passengertyres", "passengertires"].includes(normalisedValue)) {
      addProductFilter("Tyres", "Passenger");
      return true;
    }

    const matchedButton = categoryButtons.find((button) => normaliseSearch(button.dataset.catalogCategory) === normalisedValue);

    if (matchedButton) {
      addProductFilter(matchedButton.dataset.catalogCategory || "All");
      return true;
    }

    return false;
  };

  const applyInitialFiltersFromUrl = () => {
    const brandParam = urlParams.get("brand") || urlParams.get("catalogBrand");
    const categoryParam = urlParams.get("category");
    const searchParam = urlParams.get("q") || urlParams.get("search");

    if (categoryParam) {
      const didApplyPreset = applyFilterPreset(categoryParam);

      if (didApplyPreset) {
        updateFilterControls();
      }
    }

    populateBrandOptions({ preserveSelection: false });

    if (brandSelect && brandParam) {
      const matchedBrand = bestBrandMatchFor(brandParam, brandsForCategory());

      if (matchedBrand) {
        brandSelect.value = matchedBrand;
      }
    }

    if (searchInput && searchParam) {
      searchInput.value = searchParam.slice(0, 80);
    }
  };

  const getPageItems = (current, total) => {
    if (total <= 5) {
      return Array.from({ length: total }, (_, index) => index + 1);
    }

    if (current <= 3) {
      return [1, 2, 3, 4, 5];
    }

    if (current >= total - 2) {
      return [total - 4, total - 3, total - 2, total - 1, total];
    }

    return [current - 2, current - 1, current, current + 1, current + 2];
  };

  const scrollShopResultsToTop = () => {
    const target = catalogShop.querySelector(".shop-grid-heading") || catalogShop;
    const headerOffset = (announcementBar?.offsetHeight || 0) + (siteHeader?.offsetHeight || 0) + 16;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: prefersReducedMotion ? "auto" : "smooth"
    });
  };

  const renderPagination = (totalPages) => {
    if (!pagination) {
      return;
    }

    if (totalPages <= 1) {
      pagination.hidden = true;
      pagination.innerHTML = "";
      return;
    }

    const pages = getPageItems(currentPage, totalPages);
    const pageButtons = pages.map((page) => {
      const distance = Math.abs(page - currentPage);
      const fadeClass = distance >= 2 ? "shop-pagination__item--far" : distance === 1 ? "shop-pagination__item--near" : "";
      const activeClass = page === currentPage ? " is-active" : "";
      return `<button class="shop-pagination__item ${fadeClass}${activeClass}" type="button" data-catalog-page="${page}" aria-label="Go to page ${page}" ${page === currentPage ? 'aria-current="page"' : ""}>${page}</button>`;
    }).join("");

    pagination.hidden = false;
    pagination.innerHTML = `
      <button class="shop-pagination__arrow" type="button" data-catalog-page-prev aria-label="Previous page" ${currentPage === 1 ? "disabled" : ""}>&lt;</button>
      ${pageButtons}
      <button class="shop-pagination__arrow" type="button" data-catalog-page-next aria-label="Next page" ${currentPage === totalPages ? "disabled" : ""}>&gt;</button>
    `;
  };

  const fitShopCardTitles = () => {
    if (!grid) {
      return;
    }

    grid.querySelectorAll(".shop-card__title").forEach((title) => {
      title.style.removeProperty("--shop-card-title-size");
      const computed = window.getComputedStyle(title);
      let size = Number.parseFloat(computed.fontSize) || 28;
      const minimum = 11;

      while (title.scrollWidth > title.clientWidth && size > minimum) {
        size -= 1;
        title.style.setProperty("--shop-card-title-size", `${size}px`);
      }
    });
  };

  const render = ({ resetPage = false } = {}) => {
    const query = (searchInput?.value || "").trim().toLowerCase();
    const normalisedQuery = normaliseSearch(query);
    const selectedBrand = brandSelect?.value || "All";
    const filteredProducts = products.filter((product) => {
      const matchesCategory = matchesCategoryFilter(product);
      const matchesBrand = selectedBrand === "All" || product.brand === selectedBrand;
      const matchesSearch = productSearchMatches(product, query, normalisedQuery);
      const matchesWheelSpecs = matchesWheelSpecFilters(product);

      return matchesCategory && matchesBrand && matchesSearch && matchesWheelSpecs;
    });
    const fitmentStatusRank = {
      likely: 0,
      check: 1,
      wont: 2,
      none: 3
    };
    const shouldSortByFitment = Boolean(fitmentReadStored()) && !hasAnyCatalogFilters();
    const sortedProducts = shouldSortByFitment
      ? filteredProducts
        .map((product, index) => ({
          product,
          index,
          rank: fitmentStatusRank[productFitmentStatusFor(product)?.status || "none"] ?? fitmentStatusRank.none
        }))
        .sort((left, right) => left.rank - right.rank || left.index - right.index)
        .map((entry) => entry.product)
      : filteredProducts;
    const totalPages = Math.max(1, Math.ceil(sortedProducts.length / pageSize));

    if (resetPage) {
      currentPage = 1;
    }

    currentPage = Math.min(Math.max(currentPage, 1), totalPages);
    const pageStart = (currentPage - 1) * pageSize;
    const visibleProducts = sortedProducts.slice(pageStart, pageStart + pageSize);

    if (count) {
      const visibleStart = filteredProducts.length ? pageStart + 1 : 0;
      const visibleEnd = Math.min(pageStart + visibleProducts.length, filteredProducts.length);
      count.textContent = `${visibleStart}-${visibleEnd} of ${filteredProducts.length} results`;
    }

    if (activeBrandLabel) {
      const activeFilters = [
        ...activeFilterLabels(),
        ...(selectedBrand !== "All" ? [selectedBrand] : [])
      ];

      activeBrandLabel.hidden = false;
      activeBrandLabel.innerHTML = activeFilters.length
        ? `<span class="shop-active-brand__value">${escapeHtml(activeFilters.join(" / "))}</span>`
        : `<span class="shop-active-brand__value">all products</span>`;
    }

    if (brandResetButton) {
      brandResetButton.hidden = selectedBrand === "All";
    }

    updateFilterControls();

    if (empty) {
      empty.hidden = filteredProducts.length > 0;
    }

    if (!grid) {
      return;
    }

    grid.innerHTML = visibleProducts.map((product) => {
      const safeBrand = escapeHtml(product.brand);
      const safeModel = escapeHtml(product.model);
      const mediaImage = imageFor(product);
      const hasProductImage = Boolean(mediaImage);
      const placeholderImage = placeholderImageFor(product);
      const placeholderClass = categoryClassFor(product);
      const media = mediaImage
        ? `<img src="${escapeHtml(mediaImage)}" alt="${safeBrand} ${safeModel}" loading="lazy" decoding="async">`
        : `<img class="shop-card__placeholder shop-card__placeholder--${escapeHtml(placeholderClass)}" src="${escapeHtml(placeholderImage)}" alt="" loading="lazy" decoding="async">`;

      return `
        <a class="shop-card ${hasProductImage ? "shop-card--has-image" : "shop-card--no-image"}" href="${escapeHtml(productDetailUrlFor(product))}" data-catalog-product-link data-catalog-product="${escapeHtml(product.id)}" aria-label="View ${safeBrand} ${safeModel}">
          <div class="shop-card__media" aria-hidden="true">
            ${media}
          </div>
          <div class="shop-card__body">
            ${productFitmentBadgeMarkupFor(product, "shop-card__fitment-badge")}
            <p class="shop-card__brand" aria-hidden="true">${safeBrand}</p>
            <h2 class="shop-card__title">${safeModel}</h2>
          </div>
        </a>
      `;
    }).join("");
    requestAnimationFrame(fitShopCardTitles);
    renderPagination(totalPages);
  };

  const catalogueDocumentTitle = document.title;
  const productDetail = document.createElement("section");
  productDetail.className = "catalog-product-detail";
  productDetail.dataset.catalogProductDetail = "";
  productDetail.hidden = true;
  shopWorkspace?.insertAdjacentElement("beforebegin", productDetail);
  let activeProduct = null;
  let catalogueScrollPosition = 0;
  let vehicleSummaryHighlightTimer = 0;

  const catalogueUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("product");
    return `${url.pathname}${url.search}`;
  };

  const meaningfulAvailableSizes = (product) => {
    return Array.from(new Set((Array.isArray(product.availableSizes) ? product.availableSizes : [])
      .map((size) => String(size || "").trim())
      .filter(Boolean)
      .filter((size) => !size.match(/get in contact|contact us|learn if this fits|pricing|availability/i))));
  };

  const wheelFitmentTableMarkup = (product) => {
    const rows = Array.from(new Map((product.wheelSpecs || []).map((row) => [
      [row.sku, row.diameter_in, row.width_in, row.pcd, row.offset_mm, row.centre_bore_mm, row.finish].join("::"),
      row
    ])).values()).sort((left, right) => (
      (left.diameter_in || 0) - (right.diameter_in || 0) ||
      (left.width_in || 0) - (right.width_in || 0) ||
      String(left.pcd || "").localeCompare(String(right.pcd || "")) ||
      String(left.finish || "").localeCompare(String(right.finish || ""))
    ));

    if (!rows.length) {
      const range = product.wheelSpecRange || {};
      const rangeEntries = [
        ["Sizes", Array.isArray(range.sizes) ? range.sizes : []],
        ["Diameters", Array.isArray(range.diameters) ? range.diameters.map((value) => Number.isFinite(Number(value)) ? `${Number(value)}\"` : value) : []],
        ["Widths", Array.isArray(range.widths) ? range.widths.map((value) => Number.isFinite(Number(value)) ? `${Number(value)}\"` : value) : []],
        ["PCDs", wheelRangeBoltPatterns(range)],
        ["Offsets", Array.isArray(range.offsets) ? range.offsets.map((value) => Number.isFinite(Number(value)) ? `ET${Number(value)}` : value) : []],
        ["Centre bores", Array.isArray(range.centre_bores) ? range.centre_bores.map((value) => Number.isFinite(Number(value)) ? `${Number(value)} mm` : value) : []],
        ["Finishes", Array.isArray(range.finishes) ? range.finishes : []]
      ].map(([label, values]) => [label, Array.from(new Set(values.map((value) => String(value || "").trim()).filter(Boolean)))])
        .filter(([, values]) => values.length);

      if (rangeEntries.length) {
        return `
          <div class="catalog-product-detail__fitment-empty catalog-product-detail__fitment-range">
            <strong>${wheelCoverageIsPcdComplete(product.wheelSpecCoverage) ? "Complete published manufacturer range" : "Published manufacturer range"}</strong>
            <dl class="catalog-product-detail__spec-list">
              ${rangeEntries.map(([label, values]) => `<div><dt>${escapeHtml(label)}</dt><dd>${escapeHtml(values.join(", "))}</dd></div>`).join("")}
            </dl>
            <p>These are published range values; 110 Garage will confirm the exact size, offset, bore and finish combination for your vehicle.</p>
          </div>
        `;
      }

      return `
        <div class="catalog-product-detail__fitment-empty">
          <strong>Detailed variants are being confirmed.</strong>
          <p>Send 110 Garage your vehicle details and the team will confirm size, PCD, offset, centre bore and current availability.</p>
        </div>
      `;
    }

    const diameters = Array.from(new Set(rows.map((row) => row.diameter_in).filter(Number.isFinite))).sort((a, b) => a - b);
    const activeDiameter = String(diameters[0] || "all");
    const diameterCounts = new Map(diameters.map((diameter) => [String(diameter), rows.filter((row) => row.diameter_in === diameter).length]));
    const vehicleProfile = vehicleFitmentProfile();
    const showRowFitmentStatus = Boolean(vehicleProfile.record?.vehicle);
    const hasLipSize = rows.some((row) => Number.isFinite(row.lip_size_in));
    const hasCapPart = rows.some((row) => fitmentCleanText(row.cap_part_no));
    const indicesByDiameter = new Map();
    const rowMarkup = rows.map((row) => {
      const size = Number.isFinite(row.diameter_in) && Number.isFinite(row.width_in)
        ? `${row.diameter_in}x${row.width_in}`
        : "-";
      const offset = Number.isFinite(row.offset_mm) ? `ET${row.offset_mm}` : "Confirm";
      const bore = Number.isFinite(row.centre_bore_mm) ? `${row.centre_bore_mm} mm` : "Confirm";
      const backspace = Number.isFinite(row.backspace_in) ? `${row.backspace_in}\"` : "-";
      const weight = Number.isFinite(row.wheel_weight_kg)
        ? `${row.wheel_weight_kg} kg`
        : Number.isFinite(row.wheel_weight_lb) ? `${row.wheel_weight_lb} lb` : "-";
      const load = Number.isFinite(row.load_rating_kg)
        ? `${row.load_rating_kg} kg`
        : Number.isFinite(row.load_rating_lb) ? `${row.load_rating_lb} lb` : "-";
      const lipSize = Number.isFinite(row.lip_size_in) ? `${row.lip_size_in}\"` : "-";
      const rowFitmentStatus = showRowFitmentStatus ? wheelFitmentStatusForRow(row, vehicleProfile) : null;
      const rowVariantLabel = [row.sku, size, row.pcd].map((value) => String(value || "").trim()).filter(Boolean).join(", ");
      const rowFitmentMarkup = rowFitmentStatus ? `
        <td class="catalog-product-detail__fitment-status-cell" data-label="Fitment">
          <button class="catalog-product-detail__fitment-row-status catalog-product-detail__fitment-row-status--${escapeHtml(rowFitmentStatus.status)}" type="button" data-product-fitment-row-status aria-controls="ProductVehicleSummary" aria-label="${escapeHtml(`${rowVariantLabel}: ${rowFitmentStatus.label}. ${rowFitmentStatus.detail} View selected vehicle specs.`)}" title="${escapeHtml(`${rowFitmentStatus.detail} Select to view the vehicle specs used.`)}">
            <span aria-hidden="true">${rowFitmentStatus.symbol}</span>
          </button>
        </td>
      ` : "";
      const diameter = String(row.diameter_in || "all");
      const diameterIndex = indicesByDiameter.get(diameter) || 0;
      indicesByDiameter.set(diameter, diameterIndex + 1);
      const isExtra = diameterIndex >= 10;
      const isHidden = diameter !== activeDiameter || isExtra;

      return `
        <tr data-product-fitment-diameter="${escapeHtml(diameter)}" data-product-fitment-index="${diameterIndex}"${isExtra ? " data-product-fitment-extra" : ""}${isHidden ? " hidden" : ""}>
          ${rowFitmentMarkup}
          <td data-label="Part #">${escapeHtml(row.sku || "-")}</td>
          <td data-label="Size">${escapeHtml(size)}</td>
          <td data-label="PCD">${escapeHtml(row.pcd || "Confirm")}</td>
          <td data-label="Offset">${escapeHtml(offset)}</td>
          <td data-label="Centre bore">${escapeHtml(bore)}</td>
          <td data-label="Backspace">${escapeHtml(backspace)}</td>
          <td data-label="Finish">${escapeHtml(row.finish || "Confirm")}</td>
          <td data-label="Weight">${escapeHtml(weight)}</td>
          <td data-label="Load">${escapeHtml(load)}</td>
          ${hasLipSize ? `<td data-label="Lip">${escapeHtml(lipSize)}</td>` : ""}
          ${hasCapPart ? `<td data-label="Cap">${escapeHtml(row.cap_part_no || "-")}</td>` : ""}
        </tr>
      `;
    }).join("");
    const diameterTabs = diameters.length > 1 ? `
      <div class="catalog-product-detail__diameters" role="tablist" aria-label="Wheel diameter">
        ${diameters.map((diameter, index) => `
          <button class="catalog-product-detail__diameter${index === 0 ? " is-active" : ""}" type="button" role="tab" aria-selected="${index === 0 ? "true" : "false"}" data-product-fitment-diameter-tab="${diameter}">
            ${diameter}\"
          </button>
        `).join("")}
      </div>
    ` : "";
    const activeCount = diameterCounts.get(activeDiameter) || rows.length;

    return `
      <div class="catalog-product-detail__fitment-browser" data-product-fitment-browser data-active-diameter="${escapeHtml(activeDiameter)}">
        ${diameterTabs}
        <div class="catalog-product-detail__fitment-table-wrap">
          <table class="catalog-product-detail__fitment-table${hasLipSize || hasCapPart ? " has-extended-specs" : ""}${showRowFitmentStatus ? " has-row-fitment-status" : ""}">
            <thead>
              <tr>${showRowFitmentStatus ? '<th class="catalog-product-detail__fitment-status-heading" scope="col" aria-label="Fitment status"></th>' : ""}<th>Part #</th><th>Size</th><th>PCD</th><th>Offset</th><th>Centre bore</th><th>Backspace</th><th>Finish</th><th>Weight</th><th>Load</th>${hasLipSize ? "<th>Lip</th>" : ""}${hasCapPart ? "<th>Cap</th>" : ""}</tr>
            </thead>
            <tbody>${rowMarkup}</tbody>
          </table>
        </div>
        ${Array.from(diameterCounts.values()).some((count) => count > 10) ? `<button class="catalog-product-detail__fitment-toggle" type="button" data-product-fitment-toggle data-collapsed-label="Show all ${activeCount} variants" data-expanded-label="Show fewer variants"${activeCount <= 10 ? " hidden" : ""}>Show all ${activeCount} variants</button>` : ""}
      </div>
    `;
  };

  const tyreSizeRangeMarkup = (product) => {
    const sizes = meaningfulAvailableSizes(product);

    if (!sizes.length) {
      return `
        <div class="catalog-product-detail__fitment-empty">
          <strong>Tyre variants depend on vehicle, wheel size and intended use.</strong>
          <p>110 Garage will confirm the correct size, load index, speed rating and availability before ordering.</p>
        </div>
      `;
    }

    return `
      <ul class="catalog-product-detail__tyre-sizes" aria-label="Published tyre sizes">
        ${sizes.map((size, index) => `<li${index >= 24 ? " data-product-size-extra hidden" : ""}>${escapeHtml(size)}</li>`).join("")}
      </ul>
      ${sizes.length > 24 ? `<button class="catalog-product-detail__fitment-toggle" type="button" data-product-size-toggle data-collapsed-label="Show all ${sizes.length} sizes" data-expanded-label="Show fewer sizes">Show all ${sizes.length} sizes</button>` : ""}
      <p class="catalog-product-detail__size-note">Published manufacturer range. Current Australian stock and the exact load and speed rating for your vehicle must be confirmed before ordering.</p>
    `;
  };

  const productFitmentLegendMarkup = () => `
    <div class="catalog-product-detail__fitment-key" aria-label="Fitment status guide">
      <span class="catalog-product-detail__fitment-key-title">Fitment key</span>
      <ul>
        <li data-fitment-key-status="likely"><span aria-hidden="true">&#10003;</span><p><strong>Likely fits</strong> Essential published specs align. Final clearance is still confirmed by 110 Garage.</p></li>
        <li data-fitment-key-status="check"><span aria-hidden="true">-</span><p><strong>Check fitment</strong> A match may exist, but size, offset, bore or clearance still needs confirmation.</p></li>
        <li data-fitment-key-status="wont"><span aria-hidden="true">X</span><p><strong>Won't fit</strong> No published variant matches an essential vehicle specification.</p></li>
        <li data-fitment-key-status="none"><span aria-hidden="true">?</span><p><strong>No data</strong> Automatic matching is unavailable for this product or category.</p></li>
      </ul>
    </div>
  `;

  const productVehicleSummaryMarkup = (record) => {
    if (!record?.vehicle) {
      return "";
    }

    const summary = fitmentSummaryForRecord(record);
    const vehicleName = fitmentVehicleLabel(record, false) || "Selected vehicle";
    const variant = fitmentCleanText(record.vehicle.modification?.label || record.vehicle.modification?.name);
    const specs = [
      ["Bolt pattern", summary.boltPattern || "Not listed"],
      ["Centre bore", summary.centreBore || "Not listed"],
      ["OE wheel", summary.wheelSizes || "Not listed"],
      ["OE tyre", summary.tyreSizes || "Not listed"],
      ["Offset", summary.offsets || "Not listed"]
    ];

    return `
      <section class="catalog-product-detail__vehicle-summary" id="ProductVehicleSummary" data-product-vehicle-summary tabindex="-1" aria-label="Selected vehicle specifications">
        <div class="catalog-product-detail__vehicle-summary-header">
          <span>Selected vehicle</span>
          <strong>${escapeHtml(vehicleName)}</strong>
          ${variant ? `<small>${escapeHtml(variant.replace(/\s+-\s+/g, " / "))}</small>` : ""}
        </div>
        <dl>
          ${specs.map(([label, value]) => `<div><dt>${escapeHtml(label)}</dt><dd>${escapeHtml(value)}</dd></div>`).join("")}
        </dl>
        <button class="catalog-product-detail__vehicle-link catalog-product-detail__vehicle-link--change utility-action--red-slide" type="button" data-product-fitment-inline-open>Change vehicle</button>
      </section>
    `;
  };

  const productFitmentGuidanceMarkup = (product) => {
    const storedVehicle = fitmentReadStored();
    const badge = productFitmentStatusFor(product);
    const guidanceHeader = `
      <div class="catalog-product-detail__fitment-guidance-header">
        <span>Vehicle fitment</span>
        ${badge?.detail ? `<p>${escapeHtml(badge.detail)}</p>` : ""}
      </div>
    `;

    if (product.category === "Accessories") {
      return `
        ${guidanceHeader}
        <div class="catalog-product-detail__fitment-content catalog-product-detail__fitment-content--empty">
          <div class="catalog-product-detail__fitment-current">
            <strong>Confirm compatibility</strong>
            <p>Accessory fitment, finish and current availability are confirmed by 110 Garage before ordering.</p>
          </div>
        </div>
      `;
    }

    if (product.category !== "Wheels") {
      return `
        ${guidanceHeader}
        <div class="catalog-product-detail__fitment-content">
          <div class="catalog-product-detail__fitment-copy">
            ${productFitmentLegendMarkup()}
          </div>
          ${storedVehicle ? productVehicleSummaryMarkup(storedVehicle) : `
            <section class="catalog-product-detail__vehicle-summary catalog-product-detail__vehicle-summary--empty" aria-label="Vehicle specifications">
              <div>
                <span>Vehicle specs</span>
                <strong>No vehicle selected</strong>
                <small>Add a vehicle to include its specifications with your enquiry.</small>
              </div>
              <button class="catalog-product-detail__vehicle-link" type="button" data-product-fitment-inline-open>Add vehicle</button>
            </section>
          `}
        </div>
        <div class="catalog-product-detail__vehicle-picker" data-product-fitment-inline-host hidden></div>
      `;
    }

    if (!storedVehicle) {
      return `
        ${guidanceHeader}
        <div class="catalog-product-detail__fitment-content catalog-product-detail__fitment-content--empty">
          <div class="catalog-product-detail__vehicle-prompt">
            <strong>Add your vehicle for a compatibility check</strong>
            <span class="catalog-product-detail__vehicle-arrow" aria-hidden="true"></span>
            <button class="catalog-product-detail__vehicle-link" type="button" data-product-fitment-inline-open>Add vehicle</button>
          </div>
          ${productFitmentLegendMarkup()}
        </div>
        <div class="catalog-product-detail__vehicle-picker" data-product-fitment-inline-host hidden></div>
      `;
    }

    return `
      ${guidanceHeader}
      <div class="catalog-product-detail__fitment-content">
        <div class="catalog-product-detail__fitment-copy">
          ${productFitmentLegendMarkup()}
        </div>
        ${productVehicleSummaryMarkup(storedVehicle)}
      </div>
      <div class="catalog-product-detail__vehicle-picker" data-product-fitment-inline-host hidden></div>
    `;
  };

  const relatedProductsMarkup = (product) => {
    const vehicleProfile = product.category === "Wheels" ? vehicleFitmentProfile() : null;
    const requiresLikelyFit = Boolean(vehicleProfile?.record);
    const isSimilarUse = (item) => {
      if (product.category === "Wheels" && product.wheelUse) {
        return item.wheelUse === product.wheelUse;
      }

      if (product.category === "Tyres" && product.tyreUse) {
        return item.tyreUse === product.tyreUse;
      }

      return true;
    };
    const related = products
      .filter((item) => item.id !== product.id && item.category === product.category && !item.isBrandRange)
      .filter((item) => !requiresLikelyFit || productFitmentStatusFor(item, vehicleProfile)?.status === "likely")
      .sort((left, right) => {
        const similarityScore = (item) => Number(item.brand === product.brand) * 4 + Number(isSimilarUse(item)) * 2;
        return similarityScore(right) - similarityScore(left);
      })
      .filter((item, index, list) => list.findIndex((candidate) => candidate.id === item.id) === index)
      .slice(0, 4);

    if (!related.length) {
      return "";
    }

    return `
      <section class="catalog-product-detail__related" aria-labelledby="RelatedProductsTitle">
        <div class="catalog-product-detail__section-heading">
          <h2 id="RelatedProductsTitle">Related products</h2>
        </div>
        <div class="catalog-product-detail__related-grid">
          ${related.map((item) => {
            const image = imageFor(item);
            const brandLogo = logoForBrand(item.brand);
            const media = image
              ? `<img src="${escapeHtml(image)}" alt="" loading="lazy" decoding="async">`
              : `<img class="catalog-product-detail__related-placeholder" src="${escapeHtml(placeholderImageFor(item))}" alt="" loading="lazy" decoding="async">`;
            const relatedBrandMarkup = brandLogo?.src
              ? `<span class="catalog-product-detail__related-logo" data-brand="${escapeHtml(normaliseSearch(item.brand))}" data-logo-tone="${escapeHtml(brandLogo.tone || "dark")}" aria-hidden="true"><img src="${escapeHtml(brandLogo.src)}" alt="" loading="lazy" decoding="async"></span>`
              : `<span class="catalog-product-detail__related-logo catalog-product-detail__related-logo--fallback" aria-hidden="true">${escapeHtml(item.brand)}</span>`;

            return `
              <a class="catalog-product-detail__related-item" href="${escapeHtml(productDetailUrlFor(item))}" data-catalog-product-link data-catalog-product="${escapeHtml(item.id)}" aria-label="View ${escapeHtml(item.brand)} ${escapeHtml(item.model)}">
                <span class="catalog-product-detail__related-media" aria-hidden="true">${media}</span>
                <span class="catalog-product-detail__related-meta">
                  <strong>${escapeHtml(item.model)}</strong>
                  ${relatedBrandMarkup}
                </span>
              </a>
            `;
          }).join("")}
        </div>
      </section>
    `;
  };

  const productDetailMarkup = (product) => {
    const productImages = productImagesFor(product);
    const primaryImage = productImages[0] || placeholderImageFor(product);
    const hasProductImage = productImages.length > 0;
    const brandLogo = logoForBrand(product.brand);
    const availableSizes = meaningfulAvailableSizes(product);
    const descriptionMarkup = descriptionMarkupFor(product);
    const sourceUrl = product.productUrl || product.sourceUrl || "";
    const useLabel = product.wheelUse || product.tyreUse || "";
    const headlineFitmentBadge = productFitmentBadgeMarkupFor(product, "catalog-product-detail__fitment-badge catalog-product-detail__fitment-badge--headline");
    const thumbnails = productImages.length > 1 ? `
      <div class="catalog-product-detail__thumbnails" aria-label="Product images">
        ${productImages.map((image, index) => `
          <button class="catalog-product-detail__thumbnail${index === 0 ? " is-active" : ""}" type="button" data-product-detail-thumbnail="${escapeHtml(image)}" aria-label="View image ${index + 1}">
            <img src="${escapeHtml(image)}" alt="" loading="lazy" decoding="async">
          </button>
        `).join("")}
      </div>
    ` : "";
    const brandMarkup = brandLogo?.src
      ? `<img class="catalog-product-detail__brand-logo" src="${escapeHtml(brandLogo.src)}" alt="${escapeHtml(product.brand)} logo" data-logo-tone="${escapeHtml(brandLogo.tone || "dark")}">`
      : `<p class="catalog-product-detail__brand-name">${escapeHtml(product.brand)}</p>`;
    const fitmentsSection = product.category === "Accessories" ? `
      <section class="catalog-product-detail__fitments" aria-labelledby="ProductFitmentsTitle">
        <div class="catalog-product-detail__section-heading catalog-product-detail__section-heading--fitments">
          <h2 id="ProductFitmentsTitle">Accessory compatibility</h2>
          <p class="catalog-product-detail__variant-count">Confirmed by enquiry</p>
        </div>
        <div class="catalog-product-detail__fitment-empty">
          <strong>Matched to your vehicle and wheel setup.</strong>
          <p>Send 110 Garage your vehicle details and preferred finish so the team can confirm the correct accessory and current stock.</p>
        </div>
      </section>
    ` : `
      <section class="catalog-product-detail__fitments" aria-labelledby="ProductFitmentsTitle">
        <div class="catalog-product-detail__section-heading catalog-product-detail__section-heading--fitments">
          <h2 id="ProductFitmentsTitle">${product.category === "Wheels" ? "Available fitments" : availableSizes.length ? "Available sizes" : "Choose the right size"}</h2>
          <p class="catalog-product-detail__variant-count">${product.category === "Wheels" ? `${(product.wheelSpecs || []).length} verified variant${(product.wheelSpecs || []).length === 1 ? "" : "s"}` : availableSizes.length ? `${availableSizes.length} published size${availableSizes.length === 1 ? "" : "s"}` : "Sizing support"}</p>
        </div>
        ${product.category === "Wheels" ? wheelFitmentTableMarkup(product) : tyreSizeRangeMarkup(product)}
      </section>
    `;

    return `
      <a class="catalog-product-detail__back" href="${escapeHtml(catalogueUrl())}" data-catalog-product-back>
        <span class="catalog-product-detail__back-arrow" aria-hidden="true"></span>
        All products
      </a>

      <div class="catalog-product-detail__hero">
        <div class="catalog-product-detail__gallery${hasProductImage ? "" : " is-placeholder"}">
          <div class="catalog-product-detail__main-media">
            <img class="${hasProductImage ? "" : `catalog-product-detail__placeholder catalog-product-detail__placeholder--${escapeHtml(categoryClassFor(product))}`}" src="${escapeHtml(primaryImage)}" alt="${hasProductImage ? `${escapeHtml(product.brand)} ${escapeHtml(product.model)}` : ""}" data-product-detail-main-image decoding="async">
          </div>
          ${thumbnails}
        </div>

        <div class="catalog-product-detail__summary">
          <p class="catalog-product-detail__category">${escapeHtml([product.category, useLabel].filter(Boolean).join(" / "))}</p>
          <div class="catalog-product-detail__brand">${brandMarkup}</div>
          <div class="catalog-product-detail__title-row">
            <h1 class="catalog-product-detail__title" tabindex="-1" data-product-detail-title>${escapeHtml(product.model)}</h1>
            ${headlineFitmentBadge}
          </div>
          ${descriptionMarkup ? `<p class="catalog-product-detail__description">${descriptionMarkup}</p>` : ""}

          <div class="catalog-product-detail__fitment-guidance">
            ${productFitmentGuidanceMarkup(product)}
          </div>

          <div class="catalog-product-detail__actions">
            <a class="button" href="${escapeHtml(enquiryUrlFor(product))}">Send enquiry</a>
            <p>Stock and final fitment are confirmed by 110 Garage.</p>
          </div>

          ${sourceUrl ? `<a class="catalog-product-detail__source" href="${escapeHtml(sourceUrl)}" target="_blank" rel="noopener noreferrer">Manufacturer or supplier information</a>` : ""}
        </div>
      </div>

      ${fitmentsSection}

      ${relatedProductsMarkup(product)}
    `;
  };

  const setProductHistory = (product, mode) => {
    if (!mode) {
      return;
    }

    const url = product ? productDetailUrlFor(product) : catalogueUrl();
    window.history[mode === "replace" ? "replaceState" : "pushState"]({ catalogProduct: product?.id || null }, "", url);
  };

  const openProductDetail = (product, { historyMode = "push", scroll = true } = {}) => {
    if (!activeProduct) {
      catalogueScrollPosition = window.scrollY;
    }

    activeProduct = product;
    productDetail.innerHTML = productDetailMarkup(product);
    productDetail.hidden = false;
    if (shopWorkspace) shopWorkspace.hidden = true;
    if (shopHero) shopHero.hidden = true;
    catalogShop.classList.add("is-product-detail");
    document.title = `${product.brand} ${product.model} | 110 Garage`;
    setProductHistory(product, historyMode);

    if (scroll) {
      const headerOffset = (announcementBar?.offsetHeight || 0) + (siteHeader?.offsetHeight || 0) + 12;
      const top = productDetail.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({ top: Math.max(0, top), behavior: "auto" });
    }
  };

  const closeProductDetail = ({ historyMode = "push", restoreScroll = true } = {}) => {
    if (!activeProduct && productDetail.hidden) {
      return;
    }

    activeProduct = null;
    productDetail.hidden = true;
    productDetail.innerHTML = "";
    if (shopWorkspace) shopWorkspace.hidden = false;
    if (shopHero) shopHero.hidden = false;
    catalogShop.classList.remove("is-product-detail");
    document.title = catalogueDocumentTitle;
    setProductHistory(null, historyMode);

    if (restoreScroll) {
      window.requestAnimationFrame(() => window.scrollTo({ top: catalogueScrollPosition, behavior: "auto" }));
    }
  };

  const syncProductDetailFromUrl = () => {
    const productId = new URLSearchParams(window.location.search).get("product");
    const product = products.find((item) => item.id === productId);

    if (product) {
      openProductDetail(product, { historyMode: "", scroll: !activeProduct });
    } else {
      closeProductDetail({ historyMode: "", restoreScroll: Boolean(activeProduct) });
    }
  };

  catalogShop.addEventListener("click", (event) => {
    const productLink = event.target.closest("[data-catalog-product-link]");

    if (productLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const product = products.find((item) => item.id === productLink.dataset.catalogProduct);

      if (product) {
        event.preventDefault();
        openProductDetail(product);
        return;
      }
    }

    const rowFitmentStatus = event.target.closest("[data-product-fitment-row-status]");

    if (rowFitmentStatus) {
      const vehicleSummary = productDetail.querySelector("[data-product-vehicle-summary]");

      if (vehicleSummary) {
        event.preventDefault();
        window.clearTimeout(vehicleSummaryHighlightTimer);
        vehicleSummary.classList.remove("is-fitment-highlighted");
        void vehicleSummary.offsetWidth;
        vehicleSummary.classList.add("is-fitment-highlighted");
        vehicleSummary.focus({ preventScroll: true });
        window.requestAnimationFrame(() => {
          vehicleSummary.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth", block: "center" });
        });
        vehicleSummaryHighlightTimer = window.setTimeout(() => {
          vehicleSummary.classList.remove("is-fitment-highlighted");
        }, prefersReducedMotion ? 500 : 1800);
      }

      return;
    }

    const inlineVehicleButton = event.target.closest("[data-product-fitment-inline-open]");

    if (inlineVehicleButton) {
      const guidance = inlineVehicleButton.closest(".catalog-product-detail__fitment-guidance");
      const host = guidance?.querySelector("[data-product-fitment-inline-host]");

      if (guidance && host && typeof fitmentLookup?.openInlinePicker === "function") {
        inlineVehicleButton.disabled = true;
        inlineVehicleButton.setAttribute("aria-expanded", "true");
        guidance.classList.add("is-picker-open");
        window.setTimeout(() => fitmentLookup.openInlinePicker(host), prefersReducedMotion ? 0 : 160);
      }
      return;
    }

    const backLink = event.target.closest("[data-catalog-product-back]");

    if (backLink) {
      event.preventDefault();
      closeProductDetail();
      return;
    }

    const thumbnail = event.target.closest("[data-product-detail-thumbnail]");

    if (thumbnail) {
      const mainImage = productDetail.querySelector("[data-product-detail-main-image]");

      if (mainImage) {
        mainImage.src = thumbnail.dataset.productDetailThumbnail || mainImage.src;
      }

      productDetail.querySelectorAll("[data-product-detail-thumbnail]").forEach((button) => {
        button.classList.toggle("is-active", button === thumbnail);
      });
      return;
    }

    const fitmentToggle = event.target.closest("[data-product-fitment-toggle]");

    if (fitmentToggle) {
      const browser = fitmentToggle.closest("[data-product-fitment-browser]");
      const activeDiameter = browser?.dataset.activeDiameter || "all";
      const isExpanded = fitmentToggle.getAttribute("aria-expanded") === "true";
      browser?.querySelectorAll(`[data-product-fitment-diameter="${CSS.escape(activeDiameter)}"]`).forEach((row) => {
        row.hidden = !isExpanded && Number(row.dataset.productFitmentIndex) >= 10;
      });
      fitmentToggle.setAttribute("aria-expanded", isExpanded ? "false" : "true");
      fitmentToggle.textContent = isExpanded ? fitmentToggle.dataset.collapsedLabel : fitmentToggle.dataset.expandedLabel;
      return;
    }

    const diameterTab = event.target.closest("[data-product-fitment-diameter-tab]");

    if (diameterTab) {
      const browser = diameterTab.closest("[data-product-fitment-browser]");
      const diameter = diameterTab.dataset.productFitmentDiameterTab || "all";
      const matchingRows = Array.from(browser?.querySelectorAll(`[data-product-fitment-diameter="${CSS.escape(diameter)}"]`) || []);
      browser.dataset.activeDiameter = diameter;
      browser.querySelectorAll("[data-product-fitment-diameter-tab]").forEach((button) => {
        const isActive = button === diameterTab;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-selected", isActive ? "true" : "false");
      });
      browser.querySelectorAll("[data-product-fitment-diameter]").forEach((row) => {
        row.hidden = row.dataset.productFitmentDiameter !== diameter || Number(row.dataset.productFitmentIndex) >= 10;
      });

      const toggle = browser.querySelector("[data-product-fitment-toggle]");
      if (toggle) {
        toggle.hidden = matchingRows.length <= 10;
        toggle.setAttribute("aria-expanded", "false");
        toggle.dataset.collapsedLabel = `Show all ${matchingRows.length} variants`;
        toggle.textContent = toggle.dataset.collapsedLabel;
      }
      return;
    }

    const sizeToggle = event.target.closest("[data-product-size-toggle]");

    if (sizeToggle) {
      const isExpanded = sizeToggle.getAttribute("aria-expanded") === "true";
      productDetail.querySelectorAll("[data-product-size-extra]").forEach((size) => {
        size.hidden = isExpanded;
      });
      sizeToggle.setAttribute("aria-expanded", isExpanded ? "false" : "true");
      sizeToggle.textContent = isExpanded ? sizeToggle.dataset.collapsedLabel : sizeToggle.dataset.expandedLabel;
    }
  });

  window.addEventListener("popstate", syncProductDetailFromUrl);

  categoryButtons.forEach((button) => {
    button.addEventListener("change", () => {
      toggleProductFilter(button.dataset.catalogCategory || "");
      updateFilterControls();
      populateBrandOptions();
      render({ resetPage: true });
    });
  });

  subcategoryButtons.forEach((button) => {
    button.addEventListener("change", () => {
      toggleProductSubcategory(button.dataset.catalogParentCategory || "", button.dataset.catalogSubcategory || "");
      updateFilterControls();
      populateBrandOptions();
      render({ resetPage: true });
    });
  });

  pagination?.addEventListener("click", (event) => {
    const pageButton = event.target.closest("[data-catalog-page]");
    const previousButton = event.target.closest("[data-catalog-page-prev]");
    const nextButton = event.target.closest("[data-catalog-page-next]");
    const previousPage = currentPage;

    if (pageButton) {
      currentPage = Number.parseInt(pageButton.dataset.catalogPage, 10) || 1;
      render();
    }

    if (previousButton) {
      currentPage -= 1;
      render();
    }

    if (nextButton) {
      currentPage += 1;
      render();
    }

    if (currentPage !== previousPage) {
      window.requestAnimationFrame(scrollShopResultsToTop);
    }
  });

  searchInput?.addEventListener("input", () => render({ resetPage: true }));
  brandSelect?.addEventListener("change", () => render({ resetPage: true }));
  wheelDiameterOptions?.addEventListener("change", (event) => {
    const input = event.target.closest("[data-catalog-wheel-diameter]");

    if (!input) {
      return;
    }

    if (selectedWheelDiameters.has(input.value)) {
      selectedWheelDiameters.delete(input.value);
    } else {
      selectedWheelDiameters.add(input.value);
    }

    updateFilterControls();
    render({ resetPage: true });
  });
  boltPatternSelect?.addEventListener("change", () => render({ resetPage: true }));
  window.addEventListener("fitment:change", () => {
    render({ resetPage: true });

    if (activeProduct) {
      openProductDetail(activeProduct, { historyMode: "", scroll: false });
    }
  });
  window.addEventListener("resize", () => window.requestAnimationFrame(fitShopCardTitles));
  brandResetButton?.addEventListener("click", () => {
    if (brandSelect) {
      brandSelect.value = "All";
    }

    render({ resetPage: true });
  });
  filtersResetButton?.addEventListener("click", () => {
    resetProductFilters();

    if (brandSelect) {
      brandSelect.value = "All";
    }

    if (searchInput) {
      searchInput.value = "";
    }

    populateBrandOptions({ preserveSelection: false });
    updateFilterControls();
    render({ resetPage: true });
  });
  applyInitialFiltersFromUrl();
  updateFilterControls();
  render();
  syncProductDetailFromUrl();
}

const brandsPage = document.querySelector("[data-brands-page]");

if (brandsPage && window.catalogData) {
  const data = window.catalogData;
  const shopUrl = brandsPage.dataset.shopUrl || "/collections/all";
  const searchForm = brandsPage.querySelector("[data-brand-search-form]");
  const searchInput = brandsPage.querySelector("[data-brand-search]");
  const alphaNav = brandsPage.querySelector("[data-brand-alpha]");
  const brandList = brandsPage.querySelector("[data-brand-list]");
  const brandCount = brandsPage.querySelector("[data-brand-count]");
  const emptyState = brandsPage.querySelector("[data-brand-empty]");
  const allAlphabetLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  let activeLetter = "";
  let brandScrollFrame = 0;

  const escapeBrandHtml = (value) => {
    return String(value).replace(/[&<>"']/g, (character) => {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "\"": "&quot;",
        "'": "&#39;"
      }[character];
    });
  };

  const normaliseBrandSearch = (value) => String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  const rawBrandLogoMap = (() => {
    const logoMapNode = brandsPage.querySelector("[data-brand-logo-map]");

    if (!logoMapNode) {
      return {};
    }

    try {
      return JSON.parse(logoMapNode.textContent || "{}");
    } catch (_error) {
      return {};
    }
  })();
  const brandLogoMap = new Map();
  Object.entries(rawBrandLogoMap).forEach(([name, logo]) => {
    brandLogoMap.set(name, logo);
    brandLogoMap.set(normaliseBrandSearch(name), logo);
  });
  const logoForBrand = (brand) => {
    return brandLogoMap.get(brand) || brandLogoMap.get(normaliseBrandSearch(brand));
  };
  const titleCaseCategory = (category) => category === "Tyres" ? "Tyres" : category === "Wheels" ? "Wheels" : category;
  const shopBrandUrlFor = (brand) => `${shopUrl}?brand=${encodeURIComponent(brand)}`;
  const firstLetterFor = (brand) => {
    const letter = String(brand || "").trim().charAt(0).toUpperCase();
    return letter.match(/[A-Z]/) ? letter : "#";
  };

  const brandMap = new Map();

  const ensureBrand = (brand) => {
    const cleanBrand = String(brand || "").trim();

    if (!cleanBrand) {
      return null;
    }

    if (!brandMap.has(cleanBrand)) {
      brandMap.set(cleanBrand, {
        name: cleanBrand,
        categories: new Set(),
        modelCount: 0,
        sourceCount: 0,
        search: normaliseBrandSearch(cleanBrand)
      });
    }

    return brandMap.get(cleanBrand);
  };

  (data.wheelBrands || []).forEach((brand) => {
    ensureBrand(brand)?.categories.add("Wheels");
  });

  (data.tyreBrands || []).forEach((brand) => {
    ensureBrand(brand)?.categories.add("Tyres");
  });

  (data.groups || []).filter((group) => group.category === "Wheels" || group.category === "Tyres").forEach((group) => {
    const record = ensureBrand(group.brand);

    if (!record) {
      return;
    }

    if (group.category) {
      record.categories.add(titleCaseCategory(group.category));
    }

    record.modelCount += Array.isArray(group.models) ? group.models.length : 0;
    record.sourceCount += group.sourceUrl ? 1 : 0;
  });

  const brands = Array.from(brandMap.values()).sort((left, right) => left.name.localeCompare(right.name));

  const groupedBrandsFor = (visibleBrands) => {
    return visibleBrands.reduce((groups, brand) => {
      const letter = firstLetterFor(brand.name);

      if (!groups.has(letter)) {
        groups.set(letter, []);
      }

      groups.get(letter).push(brand);
      return groups;
    }, new Map());
  };

  const syncBrandProgressOffset = (activeLink) => {
    if (!alphaNav) {
      return;
    }

    const progressViewport = alphaNav.closest(".brands-progress-sidebar");

    if (!progressViewport || window.getComputedStyle(progressViewport).display === "none") {
      alphaNav.style.setProperty("--brands-progress-shift", "0px");
      alphaNav.style.setProperty("--brands-progress-edge-pad", "0.18rem");
      return;
    }

    if (!activeLink) {
      alphaNav.style.setProperty("--brands-progress-shift", "0px");
      alphaNav.style.setProperty("--brands-progress-edge-pad", "0.18rem");
      return;
    }

    const viewportHeight = progressViewport.clientHeight;

    if (!viewportHeight) {
      alphaNav.style.setProperty("--brands-progress-shift", "0px");
      return;
    }

    const edgePadding = Math.max(0, (viewportHeight - activeLink.offsetHeight) / 2);
    alphaNav.style.setProperty("--brands-progress-edge-pad", `${edgePadding.toFixed(2)}px`);

    const trackHeight = alphaNav.scrollHeight;

    if (!trackHeight || trackHeight <= viewportHeight) {
      alphaNav.style.setProperty("--brands-progress-shift", "0px");
      return;
    }

    const activeCenter = activeLink.offsetTop + (activeLink.offsetHeight / 2);
    const centeredShift = (viewportHeight / 2) - activeCenter;
    const minimumShift = viewportHeight - trackHeight;
    const clampedShift = Math.max(minimumShift, Math.min(0, centeredShift));
    alphaNav.style.setProperty("--brands-progress-shift", `${clampedShift.toFixed(2)}px`);
  };

  const setActiveLetter = (letter) => {
    activeLetter = letter || "";
    const activeIndex = allAlphabetLetters.indexOf(letter);
    let activeLink = null;

    alphaNav?.querySelectorAll("[data-brand-alpha-link]").forEach((link) => {
      const linkLetter = link.dataset.brandAlphaLink || "";
      const linkIndex = allAlphabetLetters.indexOf(linkLetter);
      const isActive = linkLetter === letter;
      const isPassed = activeIndex >= 0 && linkIndex >= 0 && linkIndex <= activeIndex;
      link.classList.toggle("is-active", isActive);
      link.classList.toggle("is-passed", isPassed);
      link.setAttribute("aria-current", isActive ? "true" : "false");

      if (isActive) {
        activeLink = link;
      }
    });

    window.requestAnimationFrame(() => syncBrandProgressOffset(activeLink));
  };

  const sectionForLetter = (letter) => {
    const sections = Array.from(brandList?.querySelectorAll("[data-brand-letter-section]") || []);
    const exactSection = sections.find((section) => section.dataset.brandLetterSection === letter);

    if (exactSection) {
      return exactSection;
    }

    const targetIndex = allAlphabetLetters.indexOf(letter);

    if (targetIndex < 0) {
      return null;
    }

    const nextSection = sections.find((section) => allAlphabetLetters.indexOf(section.dataset.brandLetterSection || "") > targetIndex);

    if (nextSection) {
      return nextSection;
    }

    for (let index = sections.length - 1; index >= 0; index -= 1) {
      const sectionIndex = allAlphabetLetters.indexOf(sections[index].dataset.brandLetterSection || "");

      if (sectionIndex < targetIndex) {
        return sections[index];
      }
    }

    return null;
  };

  const updateActiveLetterFromScroll = () => {
    brandScrollFrame = 0;

    const sections = Array.from(brandList?.querySelectorAll("[data-brand-letter-section]") || []);

    if (!sections.length) {
      return;
    }

    const progressPoint = window.innerHeight * 0.5;
    let current = sections[0];
    const scrollBottom = window.scrollY + window.innerHeight;
    const pageBottom = Math.max(
      document.body.scrollHeight,
      root.scrollHeight,
      document.body.offsetHeight,
      root.offsetHeight
    );

    sections.forEach((section) => {
      const top = section.getBoundingClientRect().top;

      if (top <= progressPoint) {
        current = section;
      }
    });

    if (pageBottom - scrollBottom <= 4) {
      current = sections[sections.length - 1];
    }

    setActiveLetter(current.dataset.brandLetterSection || "");
  };

  const scheduleActiveLetterUpdate = () => {
    if (brandScrollFrame) {
      return;
    }

    brandScrollFrame = window.requestAnimationFrame(updateActiveLetterFromScroll);
  };

  const renderBrands = () => {
    const query = normaliseBrandSearch(searchInput?.value || "");
    const visibleBrands = query
      ? brands.filter((brand) => brand.search.includes(query))
      : brands;
    const groupedBrands = groupedBrandsFor(visibleBrands);
    const letters = Array.from(groupedBrands.keys()).sort((left, right) => left.localeCompare(right));

    if (brandCount) {
      brandCount.textContent = visibleBrands.length === 1
        ? "1 brand"
        : `${visibleBrands.length} brands`;
    }

    if (emptyState) {
      emptyState.hidden = visibleBrands.length > 0;
    }

    if (alphaNav) {
      const availableLetters = new Set(letters);
      alphaNav.innerHTML = allAlphabetLetters.map((letter) => {
        const unavailableClass = availableLetters.has(letter) ? "" : " is-unavailable";
        const ariaLabel = availableLetters.has(letter)
          ? `Jump to ${letter} brands`
          : `Jump near ${letter} brands`;

        return `<a class="brands-progress__link${unavailableClass}" href="#BrandLetter-${escapeBrandHtml(letter)}" data-brand-alpha-link="${escapeBrandHtml(letter)}" aria-label="${escapeBrandHtml(ariaLabel)}"><span>${escapeBrandHtml(letter)}</span></a>`;
      }).join("");
    }

    if (brandList) {
      brandList.innerHTML = letters.map((letter) => {
        const cards = (groupedBrands.get(letter) || []).map((brand) => {
          const logo = logoForBrand(brand.name);
          const brandClass = ` brand-card--${normaliseBrandSearch(brand.name)}`;
          const logoClass = logo?.tone === "light" ? " brand-card--light-logo" : "";
          const logoMarkup = logo?.src
            ? `<img src="${escapeBrandHtml(logo.src)}" alt="${escapeBrandHtml(brand.name)} brand logo" loading="lazy" decoding="async" width="360" height="120">`
            : `<span class="brand-card__logo-fallback">${escapeBrandHtml(brand.name)}</span>`;

          return `
            <a class="brand-card${brandClass}${logoClass}" href="${escapeBrandHtml(shopBrandUrlFor(brand.name))}" aria-label="Shop ${escapeBrandHtml(brand.name)}">
              <span class="brand-card__logo" aria-hidden="true">${logoMarkup}</span>
              <span class="brand-card__name">${escapeBrandHtml(brand.name)}</span>
            </a>
          `;
        }).join("");

        return `
          <section class="brands-letter-section" id="BrandLetter-${escapeBrandHtml(letter)}" data-brand-letter-section="${escapeBrandHtml(letter)}">
            <h2>${escapeBrandHtml(letter)}</h2>
            <div class="brands-grid">${cards}</div>
          </section>
        `;
      }).join("");
    }

    setActiveLetter(letters[0] || "");
    window.requestAnimationFrame(updateActiveLetterFromScroll);
  };

  alphaNav?.addEventListener("click", (event) => {
    const link = event.target.closest("[data-brand-alpha-link]");

    if (!link) {
      return;
    }

    event.preventDefault();
    const target = sectionForLetter(link.dataset.brandAlphaLink || "");

    if (!target) {
      return;
    }

    const scrollOffset = Math.min(window.innerHeight * 0.32, 240);
    const top = target.getBoundingClientRect().top + window.scrollY - scrollOffset;
    window.scrollTo({ top, behavior: prefersReducedMotion ? "auto" : "smooth" });
    setActiveLetter(target.dataset.brandLetterSection || link.dataset.brandAlphaLink || "");
  });

  searchInput?.addEventListener("input", renderBrands);
  searchForm?.addEventListener("submit", (event) => {
    event.preventDefault();
    brandList?.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth", block: "start" });
  });
  window.addEventListener("scroll", scheduleActiveLetterUpdate, { passive: true });
  window.addEventListener("resize", scheduleActiveLetterUpdate);
  renderBrands();
}

if (brandsPage && !window.catalogData) {
  brandsPage.querySelectorAll(".brands-letter-section").forEach((section) => {
    if (!section.querySelector(".brand-card")) {
      section.remove();
    }
  });
}

const contactMessage = document.querySelector("#ContactFormMessage");
const contactReference = document.querySelector("[data-contact-product-reference]");
const contactReferenceText = document.querySelector("[data-contact-product-reference-text]");
const contactReferenceRemove = document.querySelector("[data-contact-product-reference-remove]");
const contactReferenceMedia = document.querySelector("[data-contact-product-reference-media]");
const contactReferenceImage = document.querySelector("[data-contact-product-reference-image]");
const contactReferenceProduct = document.querySelector("[data-contact-product-input]");
const contactReferenceBrand = document.querySelector("[data-contact-brand-input]");
const contactReferenceCategory = document.querySelector("[data-contact-category-input]");
const contactReferenceSource = document.querySelector("[data-contact-source-input]");
const contactFitmentReference = document.querySelector("[data-contact-fitment-reference]");
const contactFitmentReferenceText = document.querySelector("[data-contact-fitment-reference-text]");
const contactFitmentReferenceRemove = document.querySelector("[data-contact-fitment-reference-remove]");
const contactFitmentVehicleInput = document.querySelector("[data-contact-fitment-vehicle-input]");
const contactFitmentModificationInput = document.querySelector("[data-contact-fitment-modification-input]");
const contactFitmentBoltPatternInput = document.querySelector("[data-contact-fitment-bolt-pattern-input]");
const contactFitmentCentreBoreInput = document.querySelector("[data-contact-fitment-centre-bore-input]");
const contactFitmentWheelSizesInput = document.querySelector("[data-contact-fitment-wheel-sizes-input]");
const contactFitmentTyreSizesInput = document.querySelector("[data-contact-fitment-tyre-sizes-input]");
const contactFitmentOffsetsInput = document.querySelector("[data-contact-fitment-offsets-input]");
const contactFitmentSourceInput = document.querySelector("[data-contact-fitment-source-input]");
const contactVehicleMakeInput = document.querySelector("[data-contact-vehicle-make]");
const contactVehicleYearInput = document.querySelector("[data-contact-vehicle-year]");
const contactVehicleModelInput = document.querySelector("[data-contact-vehicle-model]");

if (contactMessage) {
  const contactForm = contactMessage.closest("form");
  const contactSubmit = contactForm?.querySelector(".contact-form__submit");
  const contactHoneypots = Array.from(contactForm?.querySelectorAll("[data-contact-honeypot]") || []);
  const contactSpamStatus = contactForm?.querySelector("[data-contact-spam-status]");
  const requiredFields = Array.from(contactForm?.querySelectorAll("[data-contact-required]") || []);
  const contactMethodFields = Array.from(contactForm?.querySelectorAll("[data-contact-method]") || []);
  const contactMethodError = contactForm?.querySelector("[data-contact-method-error]");
  const contactStartedAt = Date.now();
  const minimumSubmitDelay = Math.max(0, Number.parseInt(contactForm?.dataset.contactMinSeconds || "0", 10) * 1000);
  const contactSubmitLabel = contactSubmit?.dataset.contactSubmitLabel || contactSubmit?.textContent?.trim() || "Submit";
  let contactCountdownTimer = 0;
  const contactParams = new URLSearchParams(window.location.search);
  const contactParam = (name, maxLength = 160) => (contactParams.get(name) || "").trim().slice(0, maxLength);
  const productQuery = contactParam("product", 140);
  const brandQuery = contactParam("brand", 80);
  const categoryQuery = contactParam("category", 40);
  const sourceQuery = contactParam("source", 420);
  const imageQuery = contactParam("image", 640);
  const safeReferenceImage = (() => {
    if (!imageQuery) {
      return "";
    }

    try {
      const imageUrl = new URL(imageQuery, window.location.origin);
      return ["http:", "https:"].includes(imageUrl.protocol) ? imageUrl.href : "";
    } catch (_error) {
      return "";
    }
  })();
  const fitmentQueryNames = [
    "fitmentVehicle",
    "fitmentModification",
    "fitmentBoltPattern",
    "fitmentCenterBore",
    "fitmentWheelSizes",
    "fitmentTyreSizes",
    "fitmentOffsets",
    "fitmentSource",
    "vehicleYear",
    "vehicleMake",
    "vehicleModel"
  ];
  const fitmentRecordFromParams = () => {
    const vehicleLabel = contactParam("fitmentVehicle", 220);
    const vehicleYear = contactParam("vehicleYear", 12);
    const vehicleMake = contactParam("vehicleMake", 90);
    const vehicleModel = contactParam("vehicleModel", 90);
    const modification = contactParam("fitmentModification", 220);
    const boltPattern = contactParam("fitmentBoltPattern", 80);
    const centreBore = contactParam("fitmentCenterBore", 80);
    const wheelSizes = contactParam("fitmentWheelSizes", 360);
    const tyreSizes = contactParam("fitmentTyreSizes", 360);
    const offsets = contactParam("fitmentOffsets", 220);
    const source = contactParam("fitmentSource", 120) || "Wheel-Size v2";

    if (![vehicleLabel, vehicleYear, vehicleMake, vehicleModel, modification, boltPattern, centreBore, wheelSizes, tyreSizes, offsets].some(Boolean)) {
      return null;
    }

    return {
      source,
      label: vehicleLabel,
      vehicle: {
        year: vehicleYear,
        make: { label: vehicleMake },
        model: { label: vehicleModel },
        modification: { label: modification }
      },
      fitment: {
        boltPattern,
        centreBore,
        wheelSizes,
        tyreSizes,
        offsets
      }
    };
  };
  let activeFitmentRecord = fitmentRecordFromParams() || fitmentReadStored();
  let activeFitmentSummary = activeFitmentRecord ? fitmentSummaryForRecord(activeFitmentRecord) : null;
  const removeQueryParams = (names) => {
    const cleanParams = new URLSearchParams(window.location.search);
    names.forEach((name) => cleanParams.delete(name));
    const query = cleanParams.toString();
    const cleanUrl = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash || ""}`;
    window.history.replaceState({}, "", cleanUrl);
  };
  const contactMessageFromContext = () => {
    if (!activeFitmentSummary) {
      return `Hi, I would like to enquire about ${productQuery}.\n\nMy vehicle is: `;
    }

    const lines = [
      productQuery
        ? `Hi, I would like to enquire about ${productQuery}.`
        : "Hi, I would like to enquire about wheel and tyre fitment.",
      "",
      "Vehicle specs:",
      `Vehicle: ${activeFitmentSummary.vehicle}`
    ];

    if (activeFitmentSummary.modification) {
      lines.push(`Variant: ${activeFitmentSummary.modification}`);
    }

    if (activeFitmentSummary.boltPattern) {
      lines.push(`Bolt pattern: ${activeFitmentSummary.boltPattern}`);
    }

    if (activeFitmentSummary.centreBore) {
      lines.push(`Centre bore: ${activeFitmentSummary.centreBore}`);
    }

    if (activeFitmentSummary.wheelSizes) {
      lines.push(`OE wheel sizes: ${activeFitmentSummary.wheelSizes}`);
    }

    if (activeFitmentSummary.tyreSizes) {
      lines.push(`OE tyre sizes: ${activeFitmentSummary.tyreSizes}`);
    }

    if (activeFitmentSummary.offsets) {
      lines.push(`Offsets: ${activeFitmentSummary.offsets}`);
    }

    lines.push("", "Please confirm fitment and availability.");
    return lines.join("\n");
  };
  const contactFitmentInputs = [
    contactFitmentVehicleInput,
    contactFitmentModificationInput,
    contactFitmentBoltPatternInput,
    contactFitmentCentreBoreInput,
    contactFitmentWheelSizesInput,
    contactFitmentTyreSizesInput,
    contactFitmentOffsetsInput,
    contactFitmentSourceInput
  ];
  let lastGeneratedContactMessage = "";
  const syncVehicleField = (field, nextValue, previousValue) => {
    if (!field) {
      return;
    }

    const currentValue = field.value.trim();
    const previousAutoValue = String(previousValue || "").trim();

    if (!currentValue || currentValue === previousAutoValue) {
      field.value = nextValue || "";
    }
  };
  const renderContactFitment = (record, { updateMessage = false } = {}) => {
    const previousRecord = activeFitmentRecord;
    const previousAutoMessage = lastGeneratedContactMessage;
    activeFitmentRecord = record || null;
    activeFitmentSummary = activeFitmentRecord ? fitmentSummaryForRecord(activeFitmentRecord) : null;

    if (contactFitmentReference) {
      contactFitmentReference.hidden = !activeFitmentSummary;
    }

    if (contactFitmentReferenceText) {
      contactFitmentReferenceText.textContent = activeFitmentSummary?.vehicle || "Selected vehicle";
    }

    const fitmentValues = activeFitmentSummary
      ? [
          activeFitmentSummary.vehicle,
          activeFitmentSummary.modification,
          activeFitmentSummary.boltPattern,
          activeFitmentSummary.centreBore,
          activeFitmentSummary.wheelSizes,
          activeFitmentSummary.tyreSizes,
          activeFitmentSummary.offsets,
          activeFitmentSummary.source
        ]
      : [];

    contactFitmentInputs.forEach((input, index) => {
      if (input) {
        input.value = fitmentValues[index] || "";
      }
    });

    syncVehicleField(
      contactVehicleMakeInput,
      activeFitmentRecord?.vehicle?.make?.label,
      previousRecord?.vehicle?.make?.label
    );
    syncVehicleField(
      contactVehicleYearInput,
      activeFitmentRecord?.vehicle?.year,
      previousRecord?.vehicle?.year
    );
    syncVehicleField(
      contactVehicleModelInput,
      activeFitmentRecord?.vehicle?.model?.label,
      previousRecord?.vehicle?.model?.label
    );

    if (updateMessage) {
      const canReplaceMessage = !contactMessage.value.trim() || contactMessage.value === previousAutoMessage;
      const nextAutoMessage = productQuery || activeFitmentRecord ? contactMessageFromContext() : "";

      if (canReplaceMessage) {
        contactMessage.value = nextAutoMessage;
        lastGeneratedContactMessage = nextAutoMessage;
      } else {
        lastGeneratedContactMessage = "";
      }
    }
  };

  renderContactFitment(activeFitmentRecord, { updateMessage: true });

  if (productQuery && contactReference) {
    const referenceLabel = [categoryQuery, productQuery].filter(Boolean).join(" - ");
    contactReference.hidden = false;
    contactReferenceText.textContent = referenceLabel;

    if (contactReferenceImage && contactReferenceMedia && safeReferenceImage) {
      contactReferenceImage.src = safeReferenceImage;
      contactReferenceImage.alt = productQuery;
      contactReferenceMedia.hidden = false;
      contactReference.classList.add("has-product-image");
      contactReferenceImage.addEventListener("error", () => {
        contactReferenceMedia.hidden = true;
        contactReference.classList.remove("has-product-image");
      }, { once: true });
    }

    if (contactReferenceProduct) {
      contactReferenceProduct.value = productQuery;
    }

    if (contactReferenceBrand) {
      contactReferenceBrand.value = brandQuery;
    }

    if (contactReferenceCategory) {
      contactReferenceCategory.value = categoryQuery;
    }

    if (contactReferenceSource) {
      contactReferenceSource.value = sourceQuery;
    }
  }

  window.addEventListener("fitment:change", (event) => {
    renderContactFitment(event.detail?.record || null, { updateMessage: true });
    removeQueryParams(fitmentQueryNames);
  });

  contactReferenceRemove?.addEventListener("click", () => {
    contactReference.hidden = true;
    contactReference.classList.remove("has-product-image");
    contactReferenceMedia?.setAttribute("hidden", "");

    if (contactReferenceImage) {
      contactReferenceImage.removeAttribute("src");
      contactReferenceImage.alt = "";
    }

    [contactReferenceProduct, contactReferenceBrand, contactReferenceCategory, contactReferenceSource].forEach((input) => {
      if (input) {
        input.value = "";
      }
    });

    removeQueryParams(["product", "brand", "category", "source", "image"]);
  });

  contactFitmentReferenceRemove?.addEventListener("click", () => {
    contactFitmentReference.hidden = true;
    [
      contactFitmentVehicleInput,
      contactFitmentModificationInput,
      contactFitmentBoltPatternInput,
      contactFitmentCentreBoreInput,
      contactFitmentWheelSizesInput,
      contactFitmentTyreSizesInput,
      contactFitmentOffsetsInput,
      contactFitmentSourceInput
    ].forEach((input) => {
      if (input) {
        input.value = "";
      }
    });

    fitmentClearStored();
    removeQueryParams(fitmentQueryNames);
  });

  const setFieldInvalid = (field, isInvalid) => {
    const wrapper = field?.closest(".contact-form__field");

    if (!wrapper || !field) {
      return;
    }

    wrapper.classList.toggle("is-invalid", isInvalid);
    field.setAttribute("aria-invalid", isInvalid ? "true" : "false");
  };

  const setContactSpamStatus = (message, type = "warning") => {
    if (!contactSpamStatus) {
      return;
    }

    contactSpamStatus.hidden = !message;
    contactSpamStatus.textContent = message || "";
    contactSpamStatus.dataset.statusType = type;
  };

  const clearContactSpamStatus = () => setContactSpamStatus("");

  const remainingSubmitDelay = () => Math.max(0, minimumSubmitDelay - (Date.now() - contactStartedAt));

  const updateContactSubmitReadiness = () => {
    if (!contactSubmit || !minimumSubmitDelay) {
      return;
    }

    const remaining = remainingSubmitDelay();

    if (remaining > 0) {
      contactSubmit.disabled = true;
      contactSubmit.textContent = `Submit in ${Math.ceil(remaining / 1000)}s`;
      return;
    }

    contactSubmit.disabled = false;
    contactSubmit.textContent = contactSubmitLabel;

    if (contactCountdownTimer) {
      window.clearInterval(contactCountdownTimer);
      contactCountdownTimer = 0;
    }
  };

  const hasSpamSignals = () => {
    const formText = Array.from(contactForm?.querySelectorAll("input, textarea") || [])
      .filter((field) => !field.matches("[data-contact-honeypot]"))
      .map((field) => field.value || "")
      .join(" ")
      .toLowerCase();
    const automotiveIntent = /\b(?:wheel|wheels|tyre|tyres|tire|tires|rim|rims|4x4|4wd|fitment|offset|pcd|vehicle|car|ute|truck|hilux|ranger|patrol|landcruiser|wrx|enkei|michelin|mickey|yokohama|maxxis|bf ?goodrich|bfgoodrich|cooper|pirelli|bridgestone)\b/i.test(formText);
    const suspiciousPatterns = [
      /\bshopify\b/i,
      /\be-?commerce\b/i,
      /\bseo\b/i,
      /\bbacklinks?\b/i,
      /\bguest post\b/i,
      /\bconversion\b/i,
      /\bmarketing\b/i,
      /\bstore owner\b/i,
      /\bstore manager\b/i,
      /\byour site\b/i,
      /\bwebsite\b/i,
      /\blive yet\b/i,
      /\bsetup stage\b/i,
      /\bin charge\b/i,
      /\bconversation\b/i,
      /\bonetengarage\b/i,
      /\bcasino\b/i,
      /\bcrypto\b/i,
      /\bloan\b/i,
      /\btelegram\b/i,
      /\bwhats?app\b/i
    ];
    const suspiciousCount = suspiciousPatterns.reduce((total, pattern) => total + (pattern.test(formText) ? 1 : 0), 0);
    const linkCount = (formText.match(/(?:https?:\/\/|www\.|\.com\b|\.net\b|\.org\b|\.io\b|\.co\b)/g) || []).length;
    const hasVeryShortGenericMessage = contactMessage.value.trim().length < 42 && /\b(?:hello|hi|good day|curiosity|urgent|question)\b/i.test(formText);

    return !automotiveIntent && (suspiciousCount >= 2 || linkCount >= 2 || (suspiciousCount >= 1 && hasVeryShortGenericMessage));
  };

  if (contactSubmit && minimumSubmitDelay) {
    updateContactSubmitReadiness();
    contactCountdownTimer = window.setInterval(updateContactSubmitReadiness, 250);
  }

  [...requiredFields, ...contactMethodFields].forEach((field) => {
    field.addEventListener("input", () => {
      setFieldInvalid(field, false);
      clearContactSpamStatus();

      if (contactMethodFields.some((methodField) => methodField.value.trim())) {
        contactMethodFields.forEach((methodField) => setFieldInvalid(methodField, false));

        if (contactMethodError) {
          contactMethodError.hidden = true;
        }
      }
    });
  });

  contactForm?.addEventListener("submit", (event) => {
    if (contactHoneypots.some((field) => field.value.trim())) {
      event.preventDefault();
      return;
    }

    if (remainingSubmitDelay() > 0) {
      event.preventDefault();
      updateContactSubmitReadiness();
      setContactSpamStatus("Please wait a few seconds before sending. This helps us block automated spam.", "notice");
      return;
    }

    if (hasSpamSignals()) {
      event.preventDefault();
      setContactSpamStatus("This message looks like automated website spam and was not sent. If this is a genuine wheel or tyre enquiry, please mention your vehicle, product or fitment details, or call us directly.");
      contactMessage.focus({ preventScroll: true });
      contactMessage.scrollIntoView({ behavior: "auto", block: "center" });
      return;
    }

    let firstInvalidField = null;

    requiredFields.forEach((field) => {
      const isInvalid = !field.value.trim();
      setFieldInvalid(field, isInvalid);

      if (isInvalid && !firstInvalidField) {
        firstInvalidField = field;
      }
    });

    const emailField = contactForm.querySelector("#ContactFormEmail");
    const hasContactMethod = contactMethodFields.some((field) => field.value.trim());
    const hasInvalidEmail = Boolean(emailField?.value.trim()) && !emailField.validity.valid;

    contactMethodFields.forEach((field) => {
      const isInvalid = !hasContactMethod || (field === emailField && hasInvalidEmail);
      setFieldInvalid(field, isInvalid);

      if (isInvalid && !firstInvalidField) {
        firstInvalidField = field;
      }
    });

    if (contactMethodError) {
      contactMethodError.hidden = hasContactMethod && !hasInvalidEmail;
      contactMethodError.textContent = hasInvalidEmail
        ? "Use a valid email address, or leave email blank and add your phone number."
        : "Add an email or phone number so we can reply.";
    }

    if (firstInvalidField) {
      event.preventDefault();
      firstInvalidField.focus({ preventScroll: true });
      firstInvalidField.scrollIntoView({ behavior: "auto", block: "center" });
      return;
    }

    if (contactSubmit) {
      contactSubmit.disabled = true;
      contactSubmit.textContent = "Sending...";
    }
  });
}
